export default {
    "MIME-Version": "1.0",
    "Content-Type": "text/plain; charset=utf-8",
    "Content-Transfer-Encoding": "8bit",
    "X-Generator": "Ideo Core",
    "PO-Revision-Date": "2025-01-16T18:28:34.729Z",
    "Language": "pl-PL",
    "Messages": {
        "1": "",
        "2": "",
        "3": "",
        "4": "",
        "%0 %1 temu": "",
        "%0 ostrzeżeń": "",
        "%0 plików": "",
        "%0 wierszy · %1 px": "",
        "%0 z %1": "",
        "%0 z %1 uprawnień aktywnych": "",
        "%0 z 12 kolumn siatki": "",
        "%0 zaznaczono": "",
        "%0 znaków": "",
        "<Brak nazwy>": "",
        "<iframe src=\"...\"></iframe>": "",
        "1 godzina": "",
        "1 ostrzeżenie": "",
        "1:1 kwadrat": "",
        "10 minut": "",
        "1024x1024": "",
        "1024x1536": "",
        "12 godzin": "",
        "15 minut": "",
        "1536x1024": "",
        "16:9 panoramiczny": "",
        "24 godziny": "",
        "3 godziny": "",
        "3:4 portret": "",
        "30 minut": "",
        "4:3 standard": "",
        "5 minut": "",
        "6 godzin": "",
        "9:16 mobile": "",
        "Abstrakcyjne tło w kolorach marki, gradient": "",
        "Aby móc przetestować poprawność kluczy, najpierw zapisz formularz.": "",
        "Administracja": "",
        "Administracja - Kraje": "",
        "Administracja - Miasta": "",
        "Administracja - Role": "",
        "Administracja - Stanowiska pracy": "",
        "Administracja - Użytkownicy": "",
        "Administracja - Województwa": "",
        "Administracja - Zespoły": "",
        "Administrator": "",
        "Administratorzy": "",
        "Adres bazowy API dostawcy.": "",
        "Adres domenowy": "",
        "Adres e-mail": "",
        "Adres e-mail administratora": "",
        "Adres e-mail potwierdzony": "",
        "Adres email jest wymagany": "",
        "Adres email nadawcy": "",
        "Adres IP": "",
        "Adres lub connection string używany do eksportu telemetrii.": "",
        "Adres nie istnieje lub zasób został usunięty.\nSprawdź link albo poszukaj treści w panelu.": "",
        "Adres powiadomień systemowych i resetu hasła.": "",
        "Adres projektu Sentry, do którego trafiają zdarzenia.": "",
        "Adres serwera poczty wychodzącej.": "",
        "Adres URL": "",
        "Adres używany do logowania, powiadomień i odzyskiwania dostępu.": "",
        "Adres w polu „Od” wysyłanych wiadomości.": "",
        "Adres źródłowy lub nazwa miejsca, z którego pochodzi materiał.": "",
        "Adresy rozdziel przecinkami. Każdy musi zaczynać się od http lub https.": "",
        "Agent chce wykonać operację:": "",
        "AI": "",
        "Akapit": "",
        "Akcja": "",
        "Akcje": "",
        "Akcje {name}": "",
        "Akcje folderu": "",
        "Akcje pliku": "",
        "Akordeon": "",
        "Aktualizuj": "",
        "Aktualizuj zestaw": "",
        "Aktualna": "",
        "Aktualna sesja": "",
        "Aktualne hasło": "",
        "Aktywna": "",
        "Aktywne": "",
        "Aktywne sesje": "",
        "Aktywni": "",
        "Aktywny": "",
        "Aktywuj": "",
        "Akwarela": "",
        "Alt opisuje obraz osobom korzystającym z czytników ekranu i jest używany, gdy obraz nie może się załadować.": "",
        "Analiza": "",
        "Analiza obrazów": "",
        "Analiza obrazów, rozpoznawanie wzorów wizualnych": "",
        "Angielski": "",
        "Anonimizuj": "",
        "Anonimowy": "",
        "Anulowano": "",
        "Anulowano zmianę pozycji widgetu %0.": "",
        "Anuluj": "",
        "Anuluj dodawanie urządzenia": "",
        "Anuluj zmianę nazwy": "",
        "Aplikacja monitorująca": "",
        "Aplikacja uwierzytelniająca": "",
        "Aplikacja uwierzytelniająca została skonfigurowana.": "",
        "Aplikacja zostanie zrestartowana w przeciągu maksymalnie 60 sekund.": "",
        "Aranżacja": "",
        "Artykuł": "",
        "Asystent AI": "",
        "Asystent będzie wykonywał wszystkie dozwolone operacje bez pytania, również nieodwracalne usuwanie danych.": "",
        "Asystent czeka na Twoje potwierdzenie.": "",
        "Asystent napotkał błąd serwera. Spróbuj ponownie za chwilę.": "",
        "Asystent nie jest włączony w konfiguracji AI. Skontaktuj się z administratorem.": "",
        "Asystent nie widzi Edito": "",
        "Asystent pracuje...": "",
        "Asystent prosi o repozytorium": "",
        "Asystent zakończył zadanie.": "",
        "Automatyczne zamknięcie panelu. Najedź kursorem, aby wstrzymać.": "",
        "Autonomiczny": "",
        "Autor": "",
        "Autoryzacja wymagana": "",
        "Azure AD": "",
        "Azure Application Insights": "",
        "Bardzo dobre": "",
        "Basic Auth": "",
        "Baza danych": "",
        "Bez koloru": "",
        "Bez potwierdzeń, również przy usuwaniu": "",
        "Bez przycinania": "",
        "Bezpieczeństwo": "",
        "Bezpieczne połączenie SSL": "",
        "Biblioteka": "",
        "Biblioteka plików": "",
        "Błąd 404. Nie znaleziono żądanego zasobu.": "",
        "Błąd asystenta": "",
        "Błąd cofania zmian": "",
        "Błąd pobierania rozmów": "",
        "Błąd pobierania rozmowy": "",
        "Błąd połączenia": "",
        "Błąd potwierdzenia operacji": "",
        "Błąd serwera": "",
        "Błąd wysyłania załącznika": "",
        "Błędne": "",
        "Błędy": "",
        "Błękitny": "",
        "Blok kodu": "",
        "Blokada konta": "",
        "Blokada konta do": "",
        "Blokada konta i sesja": "",
        "Blokady": "",
        "Bool": "",
        "Brak": "",
        "Brak aktywnych ankiet z odpowiedziami do pokazania.": "",
        "Brak aktywnych sesji.": "",
        "Brak aktywnych zastępstw w wybranym miesiącu.": "",
        "Brak danych": "",
        "Brak danych inspekcji": "",
        "Brak dodatkowych metadanych": "",
        "Brak dodatkowych stylów": "",
        "Brak dostawcy": "",
        "Brak dostępnych opcji": "",
        "Brak elementów": "",
        "Brak elementów.": "",
        "Brak ikon pasujących do wyszukiwania.": "",
        "Brak kluczy": "",
        "Brak nowych powiadomień.": "",
        "Brak ostrzeżeń": "",
        "Brak pasujących dashboardów.": "",
        "Brak pasujących kolumn": "",
        "Brak pasujących plików": "",
        "Brak pasujących ról.": "",
        "Brak pasujących zestawów": "",
        "Brak pliku": "",
        "Brak produktów do wyświetlenia według aktualnych kryteriów.": "",
        "Brak przypisania": "",
        "Brak ról": "",
        "Brak rozmów": "",
        "Brak różnic między wersjami": "",
        "Brak skonfigurowanych urządzeń": "",
        "Brak treści": "",
        "Brak treści do wyświetlenia w wybranym zakresie.": "",
        "Brak uprawnień": "",
        "Brak uprawnień do asystenta.": "",
        "Brak użytkownika": "",
        "Brak użytkowników lub rejestracji do wyświetlenia w tym zakresie.": "",
        "Brak wersji": "",
        "Brak witryn.": "",
        "Brak wpisów do wyświetlenia": "",
        "Brak wpisów w dzienniku.": "",
        "Brak wyboru": "",
        "Brak wyników": "",
        "Brak wyników dla podanego wyszukiwania.": "",
        "Brak zapamiętanych urządzeń.": "",
        "Brak zapisanych zestawów": "",
        "Brak zdefiniowanych ról.": "",
        "Brak zmian dla wybranego filtra": "",
        "Brakuje emoji?": "",
        "Brakuje informacji o typie jednego z plików. Odśwież listę.": "",
        "Brakuje znaku?": "",
        "Breakpoint nieustawiony": "",
        "Brzoskwiniowy": "",
        "Build": "",
        "Cały obraz": "",
        "Caption wyświetla się nad tabelą i poprawia jej dostępność dla czytników ekranu.": "",
        "Chat": "",
        "Chat i krótkie podsumowania o niskiej latencji.": "",
        "Chat, generowanie treści i podsumowań - szybkie odpowiedzi": "",
        "Chat, generowanie treści i podsumowań - zaawansowane odpowiedzi": "",
        "Chat, generowanie treści i podsumowań.": "",
        "Ciemny nagłówek": "",
        "Claude Code - instalacja i pierwsze kroki": "",
        "Claude Code - połączenia MCP": "",
        "Claude Code Desktop - rozpoczęcie pracy": "",
        "Claude nie pokazuje karty Code": "",
        "Claymation": "",
        "Client ID": "",
        "Client Secret": "",
        "Co {interval} {unit}": "",
        "co 3 miesiące": "",
        "co 30 dni": "",
        "co 6 miesięcy": "",
        "Co będzie potrzebne": "",
        "Co było nie tak? (opcjonalnie)": "",
        "Co godzinę": "",
        "Co któreś": "",
        "Co miesiąc": "",
        "Co minutę": "",
        "Co możesz zrobić": "",
        "co rok": "",
        "Co zrobić": "",
        "Codex - aplikacja i instalacja": "",
        "Codex - konfiguracja projektu": "",
        "Codex - projekty i foldery": "",
        "Codziennie": "",
        "Cofanie w toku...": "",
        "Cofnąć te zmiany? Wykonam operacje odwrotne przez narzędzia CMS.": "",
        "Cofnięcie odrzucone — zmiana pozostaje.": "",
        "Cofnięto": "",
        "Cofnij": "",
        "Cofnij zmiany": "",
        "Coś nie zadziałało po naszej stronie.\nSpróbuj ponownie za chwilę.": "",
        "Coś nie zadziałało po naszej stronie.\nZdarzenie zostało zapisane - spróbuj ponownie za chwilę.": "",
        "Cron": "",
        "CSS gradientu": "",
        "Cyberpunk": "",
        "cyfra %0 z %1": "",
        "Cyfrowe malarstwo": "",
        "Cytat": "",
        "Czas na zatwierdzenie planu minął.": "",
        "Czas nieaktywności użytkownika": "",
        "Czas trwania blokady": "",
        "Czas uruchomienia": "",
        "Czego szukasz?": "",
        "czeka na potwierdzenie": "",
        "czerwiec": "",
        "Część": "",
        "Część harmonogramu": "",
        "Część wklejonej treści została usunięta ze względów bezpieczeństwa.": "",
        "Czy na pewno chcesz opuścić widok bez zapisywania?": "",
        "Czy na pewno chcesz usunąć sekcję wraz z treścią?": "",
        "Czy na pewno chcesz usunąć to urządzenie?": "",
        "Czy na pewno chcesz usunąć widget?": "",
        "Czy na pewno chcesz usunąć wybrane pliki i katalogi?": "",
        "Czy na pewno chcesz zrestartować aplikację?": "",
        "Czyści zaznaczenia w formularzu i ustawia wyrażenie * * * * *. Zmiany pozostają lokalne do kliknięcia „Zapisz”.": "",
        "Czytniki ekranu i użytkownicy nie widzą, gdzie prowadzi link bez tekstu. Taki link może też wyglądać jak przypadkowy znacznik w treści.": "",
        "Dalej": "",
        "Dane dodatkowe": "",
        "Dane inspekcji są niedostępne": "",
        "Dane pliku": "",
        "Dane po zmianie": "",
        "Dane przed zmianą": "",
        "Dane serwera używanego do wysyłki wiadomości.": "",
        "Dane techniczne": "",
        "Dane widoczne w wiadomościach wysyłanych z panelu.": "",
        "Dane wykorzystania limitu są prezentowane automatycznie, gdy źródło usług AI jest dostępne.": "",
        "Dashboard": "",
        "Dashboard aktywny": "",
        "Dashboard domyślny": "",
        "Dashboard został dodany.": "",
        "Dashboard został skopiowany.": "",
        "Dashboard został usunięty.": "",
        "Dashboard został zaktualizowane.": "",
        "Dashboardy": "",
        "Data": "",
        "Data do": "",
        "Data dodania": "",
        "Data modyfikacji": "",
        "Data od": "",
        "Data rejestracji": "",
        "Data uruchomienia": "",
        "Data usunięcia": "",
        "Data wylogowania": "",
        "Data zalogowania": "",
        "Data zdarzenia": "",
        "DateTime": "",
        "Dlaczego to problem": "",
        "Długość historii haseł": "",
        "dni": "",
        "Dni": "",
        "Dni tygodnia": "",
        "Do": "",
        "do %0 MB": "",
        "Do akceptacji": "",
        "do czasu ręcznego odblokowania": "",
        "Do filmu można dodać jedną ścieżkę napisów w formacie .vtt.": "",
        "Do lewej": "",
        "Do prawej": "",
        "Do środka": "",
        "Do tej daty użytkownik nie może się zalogować. Puste pole oznacza brak blokady.": "",
        "Dobre": "",
        "Dodaj": "",
        "Dodaj aplikację uwierzytelniającą, aby generować kody bez dostępu do skrzynki e-mail.": "",
        "Dodaj dashboard": "",
        "Dodaj dostawcę": "",
        "Dodaj filtr": "",
        "Dodaj kolejne": "",
        "Dodaj kolejne pliki": "",
        "Dodaj kolumnę": "",
        "Dodaj kolumny": "",
        "Dodaj komórki TH w pierwszym wierszu albo przebuduj tabelę.": "",
        "Dodaj krótki opis tego, co obraz wnosi do treści. Dla dekoracji zostaw pusty alt tylko wtedy, gdy komponent na to świadomie pozwala.": "",
        "Dodaj model": "",
        "Dodaj nofollow": "",
        "Dodaj opis alternatywny dla obrazka.": "",
        "Dodaj osobne grafiki dla wybranych szerokości ekranu. Presety przyspieszają pracę, a własny breakpoint pozwala wpisać dowolną wartość. Każdy wariant może mieć też własne wymiary HTML.": "",
        "Dodaj pierwszy widget, a następnie ułóż go na siatce metodą przeciągnij i upuść.": "",
        "Dodaj pliki": "",
        "Dodaj pliki albo przeciągnij je tutaj.": "",
        "Dodaj preset": "",
        "Dodaj preset, jeśli chcesz szybko ustawić popularny breakpoint, albo wpisz własną szerokość ekranu w pikselach.": "",
        "Dodaj rolę": "",
        "Dodaj sekcję": "",
        "Dodaj stop": "",
        "Dodaj tekst linku albo usuń pusty link.": "",
        "Dodaj uprawnienia": "",
        "Dodaj urządzenie": "",
        "Dodaj urządzenie uwierzytelniające": "",
        "Dodaj użytkownika": "",
        "Dodaj widget": "",
        "Dodaj własną proporcję": "",
        "Dodaj własny breakpoint": "",
        "Dodaj zastępstwo w module Zastępstwa lub zmień miesiąc w filtrze listy.": "",
        "Dodaje delikatne tło co drugiemu wierszowi, więc łatwiej śledzić dane poziomo.": "",
        "dodał": "",
        "dodane": "",
        "Dodane": "",
        "Dodanie": "",
        "Dodanie dashboardu": "",
        "Dodanie roli": "",
        "Dodanie użytkownika": "",
        "Dodanie znaku wodnego": "",
        "dodano": "",
        "Dodano": "",
        "dodany": "",
        "Dodatkowe": "",
        "Dodatkowe informacje przypisane do Twojego profilu.": "",
        "Dodatkowy krok przy logowaniu do panelu.": "",
        "Dodatkowy opis treści lub przeznaczenia pliku.": "",
        "Dodawanie plików do kolejki": "",
        "Dokument": "",
        "Dokument ma załączniki": "",
        "Dokument PDF": "",
        "Dokument Studio": "",
        "Dokument tekstowy": "",
        "Dół": "",
        "Dołącz": "",
        "Dołącz dokument Studio": "",
        "Dołącz pliki": "",
        "Dołącz stack trace": "",
        "Dołącz zasób (dokument lub plik)": "",
        "Dołącza identyfikator i podstawowe dane użytkownika do zdarzenia.": "",
        "Dołącza pełny stos wywołań do raportu błędu.": "",
        "Domyślna": "",
        "Domyślna ścieżka napisów": "",
        "Domyślne": "",
        "Domyślnie": "",
        "Domyślny": "",
        "Domyślny dashboard jest otwierany użytkownikom jako pierwszy.": "",
        "Domyślny poziom logowania": "",
        "Dopasowanie miniatur": "",
        "Dopasuj miniaturę – pokaż cały obraz": "",
        "Dostawca": "",
        "Dostawcy": "",
        "Dostęp": "",
        "Dostęp do panelu będzie ograniczony do podanych adresów. Wpisz adresy po przecinku.": "",
        "Dostęp niezdefiniowany": "",
        "Dostępna jest nowa aktualizacja": "",
        "Dostępne akcje:": "",
        "Dostępne ikony": "",
        "Double": "",
        "Dowolne": "",
        "dowolny": "",
        "Dozwolone": "",
        "Dozwolone są wyłącznie pliki JPEG i PNG.": "",
        "Dozwolone typy: image/jpeg, image/png · max %0 MB": "",
        "Drzewo": "",
        "Dsn": "",
        "Duże litery": "",
        "Duże rzymskie": "",
        "Duży układ siatki": "",
        "Działania dla zaznaczonych elementów": "",
        "Działania dla zaznaczonych elementów kosza": "",
        "Dziedzicz - z ról / domyślne": "",
        "Dziedziczone": "",
        "dzień": "",
        "Dziennik zdarzeń": "",
        "Dziś": "",
        "Dzisiaj": "",
        "E-mail": "",
        "E-mail potwierdzony": "",
        "Edito": "",
        "Edycja aranżacji - podgląd układu na danych demonstracyjnych": "",
        "Edycja aranżacji dashboardu": "",
        "Edycja Crona · {name}": "",
        "Edycja dashboardu": "",
        "Edycja i publikacja treści": "",
        "Edycja logów": "",
        "Edycja obrazu": "",
        "Edycja roli": "",
        "Edycja uprawnień": "",
        "Edycja użytkownika": "",
        "Edycja zaznaczonych": "",
        "Edytor kodu": "",
        "Edytor kodu HTML": "",
        "Edytor treści": "",
        "Edytor treści · pełny ekran": "",
        "Edytuj": "",
        "Edytuj aranżację": "",
        "Edytuj filtr": "",
        "Edytuj link": "",
        "Edytuj uprawnienia": "",
        "Edytuj wiadomość": "",
        "Ekran jest zbyt wąski": "",
        "Eksport": "",
        "Eksport śladów, metryk i logów do zewnętrznej platformy monitorującej.": "",
        "Eksportuj przefiltrowanych": "",
        "Eksportuj wszystkich": "",
        "Element został przywrócony.": "",
        "Element został trwale usunięty.": "",
        "Elementów na stronie": "",
        "Elementy": "",
        "Embedding": "",
        "Embeddingi do wyszukiwania semantycznego.": "",
        "Emoji": "",
        "Endpoint": "",
        "Esc – zamknij podgląd": "",
        "Etap": "",
        "Etap przetwarzania wiadomości": "",
        "Etap wykonania zadania": "",
        "Etykieta napisów": "",
        "Etykiety": "",
        "False": "",
        "Filtr": "",
        "Filtr widgetu": "",
        "Filtr zmian": "",
        "Filtr został usunięty": "",
        "Filtry": "",
        "Filtry listy": "",
        "Filtry wyszukiwania": "",
        "Folder": "",
        "Folder docelowy": "",
        "Folder główny": "",
        "Folder plików": "",
        "Folderów nie można wstawić w tym miejscu.": "",
        "Foldery": "",
        "Format obrazów": "",
        "Format zapisu": "",
        "Formatowanie": "",
        "Formularz": "",
        "Fotografia": "",
        "Fragment odpowiedzi": "",
        "Gdy przycisk pobrania zniknął": "",
        "Generowanie obrazów": "",
        "Generowanie obrazów zakończone": "",
        "Generowanie obrazu AI": "",
        "Generowanie, edycja i modyfikacja obrazów oraz grafik": "",
        "Generuj": "",
        "Generuj hasło": "",
        "Generuj kod QR": "",
        "Generuj metadane": "",
        "Generuj obraz": "",
        "Globalna polityka 2FA": "",
        "Globalny": "",
        "godz.": "",
        "Godziny": "",
        "Google Authenticator, Microsoft Authenticator lub podobna aplikacja TOTP.": "",
        "Góra": "",
        "Gotowe": "",
        "gotowy do pracy": "",
        "Gradient": "",
        "Grafana Cloud": "",
        "Grubość ramki": "",
        "grudzień": "",
        "Grupa": "",
        "Grupuje powiązane usługi w platformie monitorującej.": "",
        "Grupy zmian": "",
        "Harmonogram jest wykonywany według czasu UTC.": "",
        "Harmonogram zadań": "",
        "Harmonogram został zmieniony": "",
        "Hasła": "",
        "Hasła nie są identyczne.": "",
        "Hasło": "",
        "Hasło lub klucz aplikacji dla tego konta.": "",
        "Hasło musi zawierać co najmniej jeden znak specjalny, np.: ~ @ # $ % ^ & *": "",
        "Hasło zostało skopiowane.": "",
        "Hasło zostało zmienione. Zaloguj się ponownie": "",
        "high": "",
        "Historia logowania": "",
        "Historia rozmów": "",
        "Historia rozmów została wyczyszczona.": "",
        "Historia sesji": "",
        "Historia wersji": "",
        "Historia wersji ({count})": "",
        "Historia zadania": "",
        "Host": "",
        "href=\"#\" zwykle jest placeholderem zostawionym po szkicu treści. Na stronie może przewijać użytkownika do góry albo nie robić nic.": "",
        "i": "",
        "Id": "",
        "ID": "",
        "ID lub typ zadania": "",
        "Id modelu": "",
        "Id obiektu": "",
        "Id sesji": "",
        "ID zadania": "",
        "Identyfikator aplikacji Microsoft Entra.": "",
        "Identyfikator dzierżawy Microsoft 365.": "",
        "Identyfikator modelu po stronie dostawcy.": "",
        "Identyfikator zadania": "",
        "Ignoruj szybkie zapytania SQL": "",
        "Ikona chmury, płaska ilustracja wektorowa": "",
        "Ikona filtra": "",
        "Ile ostatnich haseł nie może zostać ponownie użytych (0 = bez ograniczeń).": "",
        "Im więcej szczegółów – kompozycja, światło, nastrój – tym lepszy wynik.": "",
        "Imię": "",
        "Imię i nazwisko": "",
        "Imię i nazwisko autora lub nazwa twórcy materiału.": "",
        "Import użytkowników": "",
        "Indeks dolny": "",
        "Indeks górny": "",
        "Indywidualne": "",
        "Informacje": "",
        "Informacje o typie konta i ostatnim logowaniu.": "",
        "Informacje o zdarzeniu": "",
        "Inspekcja": "",
        "Inspekcja będzie dostępna po zapisaniu konta.": "",
        "Inspekcja nie zwróciła szczegółowych wpisów uprawnień.": "",
        "Inspekcja uprawnień": "",
        "Instalacja": "",
        "Int": "",
        "Interlinia": "",
        "Jak długo konto pozostaje zablokowane przed kolejną próbą.": "",
        "Jak korzystać na co dzień": "",
        "Jakość": "",
        "Jakość obrazu": "",
        "Jasność": "",
        "Jeśli program zapyta, zatwierdź zaufanie do projektu i połączenie z serwerem „edito”.": "",
        "Jeśli program zapyta, zatwierdź zaufanie do projektu i serwera „edito”.": "",
        "Jeśli zostawisz szerokość pustą, wyrównanie użyje naturalnej szerokości tabeli.": "",
        "Język": "",
        "Język bloku kodu": "",
        "Język interfejsu panelu dla tego użytkownika.": "",
        "Język napisów": "",
        "Język zakresu": "",
        "Kadr. Strzałki przesuwają, Alt i strzałki zmieniają rozmiar. Shift zwiększa krok.": "",
        "Kadrowanie": "",
        "Kadrowanie obrazu": "",
        "kadrowanie, transformacje, filtry, znak wodny i eksport": "",
        "Kalendarz - Kategorie zasobów": "",
        "Katalog został utworzony": "",
        "Kategorie": "",
        "Kategorie powiadomień": "",
        "Kategorie widżetów": "",
        "Każdy": "",
        "Każdy układ wstawi gotową strukturę z przykładową zawartością, którą możesz od razu nadpisać.": "",
        "Klasy CSS": "",
        "Klienci": "",
        "Kliknij „Utwórz token”. Po udanym zapisie pozostaw okno otwarte: pojawi się token i sekcja „Połącz Edito z asystentem AI”, potrzebna w następnym kroku.": "",
        "Klucz API": "",
        "Klucz prywatny": "",
        "Klucz publiczny": "",
        "Klucz został skopiowany.": "",
        "Klucze nie są poprawne": "",
        "Klucze są nieprawidłowe.": "",
        "Klucze są poprawne": "",
        "Klucze są prawidłowe.": "",
        "Kod C#": "",
        "Kod CSS": "",
        "Kod do osadzenia": "",
        "Kod HTML": "",
        "Kod JavaScript": "",
        "Kod jednorazowy": "",
        "Kod jednorazowy wysyłamy na Twój adres e-mail przy każdym logowaniu.": "",
        "Kod jest nieprawidłowy lub konfiguracja wygasła. Spróbuj ponownie.": "",
        "Kod QR jest gotowy. Zeskanuj go w aplikacji uwierzytelniającej.": "",
        "Kod QR konfiguracji aplikacji uwierzytelniającej": "",
        "Kod TypeScript": "",
        "Kod Vue (Single-File Component)": "",
        "Kod weryfikacyjny": "",
        "Kod weryfikacyjny jest nieprawidłowy lub wygasł.": "",
        "Kod weryfikacyjny jest nieprawidłowy.": "",
        "Kod z wiadomości został potwierdzony. Nadaj nowe hasło do konta.": "",
        "Kod zmienia się co 30 sekund. Upewnij się, że czas na urządzeniu jest prawidłowy.": "",
        "Kod źródłowy": "",
        "Kohorta": "",
        "Kolejka": "",
        "Kolejka wysyłania": "",
        "Koło": "",
        "Kolor": "",
        "Kolor tekstu": "",
        "Kolor tła": "",
        "Kolor widżetu": "",
        "Kolor wyróżnia ikonę i linię pod nagłówkiem.": "",
        "Kolumny": "",
        "Komentarz": "",
        "Komponent React": "",
        "Komunikat": "",
        "Kończę odpowiedź...": "",
        "Konfiguracja": "",
        "Konfiguracja AI": "",
        "Konfiguracja dashboardu": "",
        "Konfiguracja harmonogramu (czas UTC)": "",
        "Konfiguracja krok po kroku": "",
        "Konfiguracja modułu Studio": "",
        "Konfiguracja została zmieniona.": "",
        "Konsola aplikacji": "",
        "Konsola aplikacji nigdy nie rejestruje logów z poniższych przestrzeni nazw:": "",
        "Konta użytkowników zostały odblokowane": "",
        "Konta użytkowników zostały usunięte z systemu": "",
        "Konta użytkowników zostały zablokowane": "",
        "Kontakty - Typ działania": "",
        "Konto": "",
        "Konto aktywne": "",
        "Konto pozostanie nieaktywne, dopóki adres e-mail nie zostanie potwierdzony.": "",
        "Konto z dostępem do panelu": "",
        "Konto zanonimizowane": "",
        "Konto, z którego wysyłana jest poczta.": "",
        "Kontrast": "",
        "Kontrolowany": "",
        "Kopiuj": "",
        "Kopiuj hasło": "",
        "Kopiuj identyfikator rozmowy": "",
        "Kopiuj klucz": "",
        "Kopiuj link": "",
        "Kopiuj odpowiedź": "",
        "Kopiuj pole": "",
        "Kopiuj polecenie": "",
        "Korzystasz z właściwego panelu i tokenu opisanego swoim imieniem i nazwiskiem.": "",
        "Kosz": "",
        "Kosz został opróżniony.": "",
        "Kotwica": "",
        "Krój czcionki": "",
        "Kroki konfiguracji MCP": "",
        "kroków": "",
        "Kropki": "",
        "Krótki opis obrazu…": "",
        "Krótki opis ułatwia rozpoznanie przeznaczenia dashboardu.": "",
        "Krótki opis zawartości obrazu, odczytywany przez czytniki ekranu.": "",
        "Krótko, czego dotyczy ten dashboard…": "",
        "Kursywa": "",
        "Kwadraty": "",
        "kwiecień": "",
        "Ładowanie": "",
        "Ładowanie logo witryn...": "",
        "Ładowanie obrazu...": "",
        "Laptop na biurku, minimalistyczna kompozycja": "",
        "lat": "",
        "lata": "",
        "Lawendowy": "",
        "Legenda": "",
        "Lewo": "",
        "Lewy dolny": "",
        "Lewy górny": "",
        "Lewy panel": "",
        "Licencja": "",
        "Liczba": "",
        "Liczba nieudanych prób logowania, po której konto zostaje zablokowane.": "",
        "Liczba obrazów": "",
        "Licznik kolejnych błędnych prób logowania.": "",
        "Limonkowy": "",
        "Linia": "",
        "Linia pozioma": "",
        "Linie": "",
        "Link": "",
        "Link bez adresu": "",
        "Link bez adresu wygląda jak aktywny element, ale nie prowadzi użytkownika do celu.": "",
        "Link bez tekstu": "",
        "Link do admina": "",
        "Link do dokumentu": "",
        "Link skopiowany do schowka.": "",
        "Link w treści publicznej nie powinien prowadzić do panelu.": "",
        "Link z href=\"#\"": "",
        "Lint nie znalazł problemów w tej treści.": "",
        "Lint treści": "",
        "lipiec": "",
        "Lista kontrolna": "",
        "Lista miejsc użycia została ograniczona.": "",
        "Lista nie zawiera jeszcze żadnych elementów.": "",
        "Lista numerowana": "",
        "Lista punktowana": "",
        "Lista rozmów jest teraz niedostępna. Spróbuj pobrać ją ponownie. Jeśli problem się powtarza, sprawdź połączenie z siecią lub spróbuj później.": "",
        "Lista rozmów odświeżona": "",
        "Lista rozmów została pobrana. Możesz wybrać rozmowę z panelu historii.": "",
        "Lista zaufanych adresów IP": "",
        "listopad": "",
        "Listy": "",
        "Log zadania został skopiowany.": "",
        "Logi poniżej tego poziomu nie będą zbierane niezależnie od pozostałych ustawień.": "",
        "Logi wydajnościowe": "",
        "Login do panelu, unikalny w całej instancji.": "",
        "Logo": "",
        "Logo witryny": "",
        "Logowanie": "",
        "Logowanie nazwą użytkownika i hasłem.": "",
        "Logowanie zakończyło się niepowodzeniem.": "",
        "Logowanie zdarzeń": "",
        "Lokalizacja": "",
        "Lokalne": "",
        "Long": "",
        "low": "",
        "Low‑poly": "",
        "Lub wybierz zakres": "",
        "luty": "",
        "macOS: w folderze „Pobrane” kliknij ZIP dwukrotnie.": "",
        "maj": "",
        "Maksymalna rozdzielczość: %0 × %1 px.": "",
        "Maksymalna szerokość ekranu (px)": "",
        "Maksymalny czas trwania zapytania uznawanego za szybkie (ms)": "",
        "Maksymalny rozmiar jednego pliku to 20 MB.": "",
        "Małe litery": "",
        "Małe rzymskie": "",
        "Malejąco": "",
        "Mały układ siatki": "",
        "Margines dolny": "",
        "Margines górny": "",
        "marzec": "",
        "Masz niezapisane zmiany.": "",
        "Materiały dodatkowe": "",
        "Media": "",
        "medium": "",
        "Medium": "",
        "Menu": "",
        "Menu konta": "",
        "Menu kontekstowe edytora": "",
        "Menu: %0": "",
        "Metadane pliku": "",
        "Metoda autentykacji": "",
        "Metoda weryfikacji": "",
        "Microsoft Aspire": "",
        "mies.": "",
        "Miesiąc": "",
        "Miesiące": "",
        "Mieszane": "",
        "Miętowy": "",
        "min": "",
        "min. 8 znaków": "",
        "Miniatura artykułu {title}": "",
        "Minimalizuj": "",
        "Minimalna długość hasła": "",
        "Minuty": "",
        "Mocniejsze obramowanie": "",
        "Model": "",
        "Model użyty przez panel dla każdego rodzaju zadania.": "",
        "Modele": "",
        "Modele pochodzą z konfiguracji wybranego dostawcy.": "",
        "Modele udostępnione w panelu wraz z ich możliwościami.": "",
        "Moduł": "",
        "Modyfikacja": "",
        "Modyfikacja obrazu przed wysłaniem": "",
        "Modyfikuj obrazy przed wysłaniem": "",
        "Moje": "",
        "Moje pliki": "",
        "Monitor kolejek": "",
        "Monitoring": "",
        "Monitoring aplikacji": "",
        "Monitorowane adresy URL dla żądań HTTP": "",
        "Monitoruj bazy danych (SQL, Redis, ElasticSearch)": "",
        "Monitoruj statystyki .NET": "",
        "Monitoruj żądania HTTP": "",
        "Morelowy": "",
        "Możesz dołączyć maksymalnie {0} zasobów.": "",
        "Możesz dołączyć maksymalnie 4 pliki.": "",
        "Możesz dołączyć obrazy oraz pliki PDF, DOCX, XLSX, TXT, MD i CSV.": "",
        "Możesz przeciągnąć tutaj kolejne pliki": "",
        "Możesz wybrać maksymalnie %0 plików.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są sychronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość modyfikacji tego konta jest ograniczona. Nieaktywne pola są synchronizowane z zewnętrzną bazą danych %0.": "",
        "Możliwość zmiany hasła jest zablokowana. Obsługa hasła znajduje się po stronie zewnętrznej bazy danych %0.": "",
        "Możliwości": "",
        "Możliwości wybranego modelu": "",
        "Mroczne fantasy": "",
        "Multimedia": "",
        "Na liście tokenów kliknij „Dodaj token”. W otwartym oknie znajdziesz formularz nowego połączenia.": "",
        "Na ten adres trafi wiadomość testowa.": "",
        "Naciśnij spację lub Enter, aby podnieść widget. Użyj strzałek oraz klawiszy Home i End, następnie naciśnij spację lub Enter, aby zatwierdzić. Escape anuluje zmianę.": "",
        "Nadaj roli nazwę i określ sposób jej przypisywania.": "",
        "Nadane bezpośrednio": "",
        "Nadawca": "",
        "Nagłówek": "",
        "Nagłówek dostaje ciemne tło i mocniejszy kontrast, więc od razu odróżnia się od danych.": "",
        "Nagłówek komórki": "",
        "Nagłówki HTTP": "",
        "Najczęściej 587 lub 465.": "",
        "Najczęstsze problemy": "",
        "Najkrótsze hasło, jakie użytkownik może ustawić.": "",
        "Najpierw ustaw obraz główny.": "",
        "Najpierw zapisz wprowadzone zmiany": "",
        "Napisy WebVTT": "",
        "Napisz wiadomość...": "",
        "Narzędzia": "",
        "Następna strona": "",
        "Następne trafienie": "",
        "Następny miesiąc": "",
        "Następny plik": "",
        "Następny rok": "",
        "Nasycenie": "",
        "Natychmiast przywraca domyślny harmonogram zadania i zapisuje tę zmianę. Zamyka okno bez potrzeby klikania „Zapisz”.": "",
        "Nawigacja mobilna": "",
        "Nazwa": "",
        "Nazwa będzie widoczna na liście dashboardów i w nagłówku widoku.": "",
        "Nazwa dashboardu": "",
        "Nazwa identyfikująca aplikację w narzędziu monitorującym.": "",
        "Nazwa katalogu": "",
        "Nazwa katalogu została zmieniona.": "",
        "Nazwa licencji lub informacja o prawach do wykorzystania materiału.": "",
        "Nazwa nadawcy": "",
        "Nazwa nowego pliku": "",
        "Nazwa nowych plików": "",
        "Nazwa pliku": "",
        "Nazwa pliku została zmieniona.": "",
        "Nazwa pola": "",
        "Nazwa roli": "",
        "Nazwa rozmowy": "",
        "Nazwa typu": "",
        "Nazwa urządzenia": "",
        "Nazwa urządzenia została zmieniona.": "",
        "Nazwa usługi": "",
        "Nazwa użytkownika": "",
        "Nazwa używana do logowania i identyfikacji konta.": "",
        "Nazwa widoczna na liście ról i w ustawieniach użytkownika.": "",
        "Nazwa widoczna przy wyborze modelu dla zadań.": "",
        "Nazwa widoczna w nagłówku widżetu.": "",
        "Nazwa wyświetlana": "",
        "Nazwa wyświetlana w aplikacji uwierzytelniającej": "",
        "Nazwa zadania": "",
        "Nazwa zestawu": "",
        "nazwa-kotwicy": "",
        "Nazwij połączenie i określ ważność dostępu.": "",
        "Nazwij urządzenie, zeskanuj kod QR i potwierdź kodem z aplikacji.": "",
        "Nazwisko": "",
        "Nie": "",
        "Nie dodano jeszcze wariantów responsywnych": "",
        "Nie dotyczy plików SVG i ICO.": "",
        "Nie jesteś zalogowany albo sesja straciła ważność.\nZaloguj się ponownie, aby wrócić do panelu.": "",
        "Nie ma dostępnych kluczy do wstawienia w treści.": "",
        "Nie ma zapisanych wpisów uprawnień do wyświetlenia.": "",
        "Nie masz jeszcze ostatnio używanych emoji.": "",
        "Nie masz uprawnień do panelu administracyjnego.": "",
        "Nie masz uprawnień do tego widoku. Stan widoku mógł ulec zmianie, odśwież i sprawdź lub spróbuj ponownie później.": "",
        "Nie możesz modyfikować profilu zastępowanego użytkownika.": "",
        "Nie możesz modyfikować uprawnień": "",
        "Nie możesz usunąć jedynego urządzenia, gdy aktywna metoda 2FA to Aplikacja uwierzytelniająca. Przełącz na metodę Email, aby móc usunąć to urządzenie.": "",
        "Nie możesz usunąć jedynego urządzenia, gdy aktywna metoda 2FA to Aplikacja uwierzytelniająca. Wyłącz 2FA lub przełącz na metodę Email, aby móc usunąć to urządzenie.": "",
        "Nie możesz usunąć jedynego urządzenia, gdy weryfikacja przez aplikację uwierzytelniającą jest wymagana przez system.": "",
        "Nie można cofnąć tej zmiany.": "",
        "Nie można dodać pliku \"%0\" z powodu: %1.": "",
        "Nie można odczytać zapisanego zestawu.": "",
        "Nie można usunąć swojego konta.": "",
        "Nie można wysłać kodu. Spróbuj zalogować się ponownie.": "",
        "Nie można wyświetlić podglądu pliku. Wybierz inny plik.": "",
        "Nie można zainicjować konfiguracji. Spróbuj ponownie.": "",
        "Nie pamiętam hasła": "",
        "Nie pokazuj tokenu ani plików konfiguracyjnych w rozmowach lub na zrzutach ekranu.": "",
        "Nie pomijaj poziomów nagłówków. Po H2 użyj H3, po H3 użyj H4 itd.": "",
        "Nie przechowuj folderu we współdzielonym OneDrive, SharePoint ani na dysku sieciowym.": "",
        "Nie udało się — ponów": "",
        "Nie udało się cofnąć": "",
        "Nie udało się odtworzyć wybranych plików.": "",
        "Nie udało się otworzyć pliku w repozytorium.": "",
        "Nie udało się otworzyć rozmowy.": "",
        "Nie udało się otworzyć strony": "",
        "Nie udało się pobrać danych ankiet.": "",
        "Nie udało się pobrać danych o użytkownikach.": "",
        "Nie udało się pobrać danych produktowych.": "",
        "Nie udało się pobrać danych z CMS.": "",
        "Nie udało się pobrać danych z Google Analytics.": "",
        "Nie udało się pobrać danych z modułu dynamicznego.": "",
        "Nie udało się pobrać danych ze sklepu.": "",
        "Nie udało się pobrać dziennika.": "",
        "Nie udało się pobrać konfiguracji AI. Sprawdź połączenie i spróbuj ponownie.": "",
        "Nie udało się pobrać konfiguracji dashboardu": "",
        "Nie udało się pobrać listy filtrów": "",
        "Nie udało się pobrać listy kolejek": "",
        "Nie udało się pobrać listy ról": "",
        "Nie udało się pobrać listy typów modeli": "",
        "Nie udało się pobrać listy zastępstw.": "",
        "Nie udało się pobrać miejsc użycia pliku.": "",
        "Nie udało się pobrać uprawnień użytkownika. Spróbuj ponownie.": "",
        "Nie udało się pobrać wersji do porównania.": "",
        "Nie udało się pobrać widżetów": "",
        "Nie udało się połączyć z asystentem. Sprawdź połączenie sieciowe.": "",
        "Nie udało się przenieść plików.": "",
        "Nie udało się przeszukać dokumentów": "",
        "Nie udało się przygotować akcji — rozmowa została odświeżona.": "",
        "Nie udało się skopiować dziennika.": "",
        "Nie udało się skopiować klucza. Skopiuj go ręcznie.": "",
        "Nie udało się skopiować polecenia. Zaznacz i skopiuj tekst ręcznie.": "",
        "Nie udało się ukończyć operacji": "",
        "Nie udało się uruchomić asystenta.": "",
        "Nie udało się usunąć rozmowy.": "",
        "Nie udało się usunąć szablonu": "",
        "Nie udało się wczytać aranżacji dashboardu": "",
        "Nie udało się wczytać opcji. Otwórz listę ponownie, aby spróbować jeszcze raz.": "",
        "Nie udało się wczytać ról": "",
        "Nie udało się wczytać rozmów": "",
        "Nie udało się wczytać szczegółów zdarzenia.": "",
        "Nie udało się wczytać uprawnień": "",
        "Nie udało się wczytać uprawnień.": "",
        "Nie udało się wczytać zawartości folderu.": "",
        "Nie udało się wczytać zestawów.": "",
        "Nie udało się wyczyścić historii rozmów.": "",
        "Nie udało się wykonać edycji zaznaczonych obrazów.": "",
        "Nie udało się wykonać planu.": "",
        "Nie udało się wysłać pliku": "",
        "Nie udało się wysłać pliku. Sprawdź połączenie.": "",
        "Nie udało się zaktualizować zestawu.": "",
        "Nie udało się załadować danych": "",
        "Nie udało się załadować elementów": "",
        "Nie udało się zapisać obrazu.": "",
        "Nie udało się zapisać oceny.": "",
        "Nie udało się zapisać ustawień dashboardu": "",
        "Nie udało się zapisać zestawu.": "",
        "Nie udało się zmienić nazwy rozmowy.": "",
        "Nie udało się zmienić trybu działania.": "",
        "Nie udostępniaj paczki ani folderu innym osobom, również przez e-mail lub komunikator.": "",
        "Nie ustawiono tego uprawnienia. Dostęp może wynikać z innych przypisań.": "",
        "Nie używaj paczki innej osoby ani paczki z innej instancji Edito.": "",
        "Nie wszystkie wybrane elementy zostały przeniesione. Nie posiadasz wymaganych uprawnień lub, w przypadku przenoszenia katalogów, katalog docelowy jest podkatalogiem katalogu źródłowego. Katalogi i pliki których nie udało się przenieść pozostały nadal w zakładce Wybrane.": "",
        "Nie wybrano ikony": "",
        "Nie wybrano jeszcze plików": "",
        "Nie wybrano obrazu do edycji": "",
        "Nie wybrano plików": "",
        "Nie wybrano pliku": "",
        "Nie wybrano żadnego użytkownika.": "",
        "Nie wykonano": "",
        "nie wymuszaj zmiany hasła": "",
        "Nie zdefiniowano jeszcze ról użytkowników.": "",
        "Nie znaleziono pasujących elementów.": "",
        "Nie znaleziono strony": "",
        "Nie znaleziono właściwego widgetu": "",
        "Nie znaleziono wyników dla „%0”": "",
        "Nie znaleziono wyników.": "",
        "Nieaktywna": "",
        "Nieaktywne": "",
        "Nieaktywni": "",
        "Nieaktywny": "",
        "Nieaktywny dashboard pozostaje zapisany, ale nie jest dostępny do użycia.": "",
        "Niebieski": "",
        "niedozwolone rozszerzenie pliku (%0)": "",
        "niedozwolony typ pliku (%0)": "",
        "Niemiecki": "",
        "Niepotwierdzeni": "",
        "Niepowodzenie": "",
        "Nieprawidłowy adres email": "",
        "Nieprawidłowy adres URL": "",
        "Nieprawidłowy format. Użyj np. 13px, 18px, 90%": "",
        "Nieprawidłowy format. Użyj np. 16px, 24px, 90%": "",
        "Nieprzeczytane": "",
        "Nieprzydatna": "",
        "Nieprzydatna odpowiedź": "",
        "nieprzydatne": "",
        "Nietrafiona odpowiedź": "",
        "Nieudane logowania": "",
        "Nieustawione": "",
        "Niezapisane zmiany": "",
        "Nieznane": "",
        "Nieznany stan": "",
        "Nieznany typ pliku": "",
        "Nieznany użytkownik": "",
        "Nikomu nie przydzielono uprawnień.": "",
        "Nowa rozmowa": "",
        "Nowa wartość": "",
        "Nowe hasło": "",
        "Nowe hasło użytkownika. Pozostaw puste, aby go nie zmieniać.": "",
        "Nowe pliki zostały zapisane.": "",
        "Nowy folder": "",
        "Nowy folder w bieżącym katalogu": "",
        "Nowy katalog powstanie w:": "",
        "Np. 820": "",
        "np. Edito": "",
        "np. iPhone": "",
        "np. Sprzedaż — podsumowanie": "",
        "np. Zestawienie wyników za Q1": "",
        "Numer sesji": "",
        "Numer telefonu": "",
        "Numeracja prawnicza": "",
        "O godzinach": "",
        "OAuth2 dla Exchange Online": "",
        "Obecny kolor": "",
        "Obiekt %0 został %1": "",
        "Obiekt JSON": "",
        "Obraz": "",
        "Obraz bez alt": "",
        "Obraz główny": "",
        "Obraz startowy": "",
        "Obraz został pomyślnie opisany": "",
        "Obraz został przetworzony ale mogły wystąpić problemy z zapisem": "",
        "Obraz został zapisany jako nowy plik.": "",
        "Obrazy": "",
        "Obrazy oraz pliki PDF, DOCX, XLSX, TXT, MD i CSV, maksymalnie 4.": "",
        "Obrazy zostały przeniesione.": "",
        "Obrót obrazu": "",
        "Ocena": "",
        "Oceny asystenta AI": "",
        "Ochrona formularzy przed automatycznymi zgłoszeniami i nadużyciami.": "",
        "Ochrona przed atakami na hasła oraz czas trwania sesji.": "",
        "Oczekująca wiadomość": "",
        "Oczekujące": "",
        "Oczekujące zaproszenia": "",
        "Oczekuje": "",
        "Od": "",
        "Od początku roku": "",
        "Odbicie pionowe": "",
        "Odbicie poziome": "",
        "Odbij X": "",
        "Odbij Y": "",
        "Odblokuj": "",
        "Odblokuj proporcje": "",
        "Odblokuj proporcje wariantu": "",
        "Odczytaj strukturę Edito i opisz dostępny workflow redaktora bez wykonywania zmian.": "",
        "Odnośniki": "",
        "Odpowiedzi na pytania o pierwsze połączenie.": "",
        "Odpowiedzi szybkie": "",
        "Odpowiedzi zaawansowane": "",
        "Odrzuć": "",
        "Odrzuca połączenie przy nieprawidłowym certyfikacie.": "",
        "Odrzucone": "",
        "Odstęp w pionie": "",
        "Odstęp w poziomie": "",
        "Odśwież": "",
        "Odśwież stronę lub sprawdź ustawienia źródła danych w widgetcie.": "",
        "Odwróć": "",
        "Odznacz": "",
        "Odzyskaj połączenie przez rotację tokenu.": "",
        "Oficjalne instrukcje i dokumentacja.": "",
        "Ogólne": "",
        "Ok": "",
        "Okręgi": "",
        "Okres": "",
        "Określ dostęp do funkcji systemu dla użytkowników przypisanych do tej roli.": "",
        "Określ dostępność i sposób wyświetlania dashboardu.": "",
        "Określ minimalny poziom ważności zdarzeń rejestrowanych w aplikacji.": "",
        "Określa, czy dashboard jest publiczny, czy dostępny wyłącznie według przypisanych uprawnień.": "",
        "Określa, czy weryfikacja dwuetapowa jest wymagana dla wszystkich użytkowników.": "",
        "Określa, jak obraz ma być pozycjonowany względem tekstu.": "",
        "Okruszki nawigacyjne": "",
        "Olej na płótnie": "",
        "Opcje linku": "",
        "Opcjonalna miniatura wyświetlana przed rozpoczęciem odtwarzania wideo.": "",
        "Opcjonalne": "",
        "Opcjonalne. Ustaw osobne width i height, jeśli ten wariant ma inną proporcję niż obraz główny.": "",
        "Opcjonalne. Ustawia atrybuty width i height na głównym obrazie renderowanym w HTML.": "",
        "Opcjonalny podpis pod obrazem…": "",
        "OpenTelemetry": "",
        "Operacja nieodwracalna": "",
        "Opis": "",
        "Opis obrazka": "",
        "Opis obrazu": "",
        "Opisy i SEO": "",
        "Opisz obraz, który chcesz stworzyć": "",
        "Opisz obraz, np. zespół w nowoczesnym biurze, ciepłe światło, szerokie ujęcie": "",
        "Opróżnić kategorię?": "",
        "Opróżnić kosz?": "",
        "Opróżnij kategorię": "",
        "Opróżnij kosz": "",
        "Optymalizuj rozdzielczość obrazów": "",
        "Opublikowany": "",
        "Opublikuj ankietę na witrynie i poczekaj na odpowiedzi albo zmień liczbę ankiet w ustawieniach widgetu.": "",
        "Opublikuj treść na witrynie, sprawdź ustawienia witryny w widgetcie lub wybierz inny okres bądź filtr.": "",
        "Opuść bez zapisywania": "",
        "Organizacja": "",
        "Oryginalny": "",
        "Oryginalny format": "",
        "Osadź": "",
        "Osiągnięto limit plików": "",
        "Osiągnięto limit wybranych plików.": "",
        "Ostatni miesiąc": "",
        "Ostatni rok": "",
        "Ostatnia aktywność": "",
        "Ostatnia strona": "",
        "Ostatnie": "",
        "Ostatnie 24h": "",
        "Ostatnie 30 dni": "",
        "Ostatnie 7 dni": "",
        "Ostatnie 90 dni": "",
        "Ostatnie logowanie": "",
        "Ostatnio używane": "",
        "Ostrzeżenia": "",
        "Ostrzeżenie": "",
        "Otwórz": "",
        "Otwórz aplikację Claude i przejdź do karty „Code”.": "",
        "Otwórz aplikację uwierzytelniającą i zeskanuj kod. Nie możesz zeskanować? Wpisz klucz ręcznie:": "",
        "Otwórz Codex i dodaj lokalny projekt z folderu na komputerze.": "",
        "Otwórz edycję układu dashboardu, a następnie ustawienia tego widgetu.": "",
        "Otwórz link": "",
        "Otwórz projekt w wybranym programie": "",
        "Otwórz rozmowę": "",
        "Otwórz tokeny dostępu": "",
        "Otwórz tokeny dostępu i znajdź token po nadanej wcześniej nazwie.": "",
        "Otwórz ustawienia widgetu (menu ⋮) i sprawdź źródło danych oraz wybrany okres.": "",
        "Otwórz w nowej karcie": "",
        "Oznacz jako nieprzeczytane": "",
        "Oznacz jako przeczytane": "",
        "Oznacz powiadomienia": "",
        "Oznacz wszystkie jako przeczytane": "",
        "Paczka odpowiada wybranemu programowi i jest rozpakowana w prywatnym miejscu.": "",
        "Paczka prowadzi do niewłaściwej instancji Edito": "",
        "Padding": "",
        "Padding komórek": "",
        "Paginacja": "",
        "Paleta": "",
        "Panel": "",
        "Panel administracyjny wymaga szerokości co najmniej 360 pikseli. Poszerz okno przeglądarki lub użyj urządzenia z szerszym ekranem.": "",
        "Panel jest chwilowo niedostępny.\nWykonujemy zaplanowaną aktualizację systemu.": "",
        "Patch": "",
        "październik": "",
        "Pełna autonomia": "",
        "Pełna ścieżka": "",
        "Pełne uprawnienia": "",
        "Pełny administrator": "",
        "Pełny dostęp do systemu": "",
        "Pełny ekran": "",
        "Pierwsza strona": "",
        "Pierwsze polecenie tylko odczytuje dane.": "",
        "Pierwsze uruchomienie. Utwórz konto głównego administratora. Będzie miało pełne uprawnienia do panelu.": "",
        "Pisz zwykłym językiem. Możesz zacząć od takich poleceń:": "",
        "Pixar": "",
        "Pixel art": "",
        "Plan gotowy": "",
        "Plan wygasł": "",
        "Plan zawiera operacje destrukcyjne i będzie wymagał dodatkowego potwierdzenia.": "",
        "Planowana": "",
        "Planowane": "",
        "Planowane zmiany": "",
        "plik": "",
        "Plik": "",
        "Plik {0}": "",
        "Plik audio": "",
        "Plik binarny": "",
        "Plik CSS": "",
        "Plik CSV": "",
        "Plik DOC": "",
        "Plik DOCX": "",
        "Plik GIF": "",
        "Plik graficzny": "",
        "Plik HTML": "",
        "Plik JPEG": "",
        "Plik JPG": "",
        "Plik MP4": "",
        "Plik nie jest jeszcze używany.": "",
        "Plik PNG": "",
        "Plik przekracza dozwolony rozmiar %0 MB.": "",
        "Plik skompresowany": "",
        "Plik WEBP": "",
        "Plik wideo": "",
        "Plik z logami": "",
        "Plik z repozytorium": "",
        "Plik ZIP": "",
        "Pliki": "",
        "Pliki w kolejce": "",
        "Pliki współdzielone": "",
        "Pliki zostały przeniesione.": "",
        "Pliki zostały wysłane": "",
        "plików": "",
        "PNG, JPG, PDF": "",
        "Po": "",
        "po %0 nieudanych próbach logowania": "",
        "Po tym czasie bezczynności użytkownik zostanie wylogowany z panelu.": "",
        "Po tym czasie panel poprosi o ustawienie nowego hasła.": "",
        "Po utracie komputera lub przypadkowym udostępnieniu paczki usuń token w panelu i utwórz nowy.": "",
        "Po włączeniu uprawnienia indywidualne i z ról nie są brane pod uwagę - użytkownik ma dostęp do wszystkiego.": "",
        "Po zakończeniu współpracy usuń token z listy tokenów dostępu.": "",
        "Po zapisaniu nowa konfiguracja zacznie obowiązywać dopiero po ponownym uruchomieniu procesu aplikacji. Zaplanuj restart w bezpiecznym momencie, ponieważ aktywne żądania i zadania w tle mogą zostać na krótko przerwane.": "",
        "Pobieranie rozmów…": "",
        "Pobierz": "",
        "Pobierz kolor z ekranu": "",
        "Pobierz paczkę od razu. Po zamknięciu widoku pełny token nie będzie ponownie dostępny. Paczka zawiera prywatny token - nie wysyłaj jej innym osobom ani nie wklejaj tokenu do rozmowy.": "",
        "Pobierz plik": "",
        "Pobierz rozmowy ponownie": "",
        "Pobierz właściwą paczkę": "",
        "Pobrano paczkę dla niewłaściwego programu": "",
        "Pobrano rozmowy": "",
        "Poczekaj na zakończenie operacji na pliku.": "",
        "Poczekaj, aż asystent skończy bieżące zadanie.": "",
        "Poczta wychodząca": "",
        "Podaj 6-cyfrowy kod z aplikacji uwierzytelniającej.": "",
        "Podaj 6-znakowy kod weryfikacyjny wysłany na Twój adres email.": "",
        "Podaj adres e-mail przypisany do konta – wyślemy jednorazowy kod do zmiany hasła.": "",
        "Podaj sześciocyfrowy kod weryfikacyjny wysłany na Twój adres e-mail.": "",
        "Podana wartość nie jest prawidłowym adresem email": "",
        "Podanie adresu API jest wymagane.": "",
        "Podanie klucza API jest wymagane.": "",
        "Podanie modelu jest wymagane.": "",
        "Podanie nazwy jest wymagane.": "",
        "Podczas próby logowania wystąpił problem z zapisem recaptcha. Spróbuj ponownie": "",
        "Podczas przesyłania plików wystąpił nieznany błąd": "",
        "Podgląd": "",
        "Podgląd multimediów": "",
        "Podgląd na żywo": "",
        "Podgląd obrazu": "",
        "Podgląd obrazu startowego": "",
        "Podgląd pliku": "",
        "Podgląd tego typu pliku nie jest dostępny.": "",
        "Podgląd uwzględnia presety, szerokość, wyrównanie i padding.": "",
        "Podkreślenie": "",
        "Podmień # na docelowy adres, kotwicę istniejącej sekcji albo usuń link.": "",
        "Podmień link na publiczny adres strony, pliku albo modułu.": "",
        "Podmień placeholder na realny adres.": "",
        "Podniesiono widget %0. Użyj klawiszy strzałek, aby zmienić jego pozycję.": "",
        "Podpis obrazu (figcaption)": "",
        "Podpis tabeli (caption)": "",
        "Podstawowe dane używane do logowania i kontaktu.": "",
        "Podsumowanie": "",
        "Pogrubienie": "",
        "Pojawi się wkrótce na docelowym ekranie.": "",
        "Pojedyncze rozwinięcie": "",
        "Pokaż bloki": "",
        "Pokaż cały obraz": "",
        "Pokaż hasło": "",
        "Pokaż historię": "",
        "Pokaż klucz prywatny": "",
        "Pokaż mniej": "",
        "Pokaż pliki": "",
        "Pokaż pozostałą zmianę": "",
        "Pokaż pozostałe {count} zmian": "",
        "Pokaż pozostałe {count} zmiany": "",
        "Pokaż rozmowy": "",
        "Pokaż szczegóły": "",
        "Pokaż tylko moje dokumenty": "",
        "Pokaż w bibliotece": "",
        "Pokaż w treści": "",
        "Pokaż więcej": "",
        "Pokaż wszystkie": "",
        "Pokaż znaki niedrukowalne": "",
        "Pokazano {0} z {1} wyników.": "",
        "Pola dodatkowe": "",
        "Połącz Edito z zewnętrznym asystentem AI przez MCP. W sekcji tokenów utwórz token dostępu i pobierz gotowy projekt dla Codexa lub Claude Code.": "",
        "Połączenia z API dostawców modeli.": "",
        "Połączenie działa, gdy asystent odczyta dostępne obszary redakcyjne bez błędu, nie poprosi o repozytorium ani kod projektu i nie wykona żadnej zmiany.": "",
        "Połączenie wcześniej działało, a teraz nie działa": "",
        "Połączenie z asystentem zostało przerwane.": "",
        "Połączenie z MCP": "",
        "Połączenie z MCP - dokumentacja Edito": "",
        "Pole \"Email\" jest wymagane.": "",
        "Pole \"Nazwa użytkownika\" jest wymagane.": "",
        "Pole \"Nazwa\" jest wymagane.": "",
        "Pole \"Szerokość\" jest wymagane.": "",
        "Pole \"Tytuł\" jest wymagane.": "",
        "Pole jest wymagane": "",
        "Pole nie może zawierać spacji": "",
        "Pole skopiowane": "",
        "Pole wymagane": "",
        "Polecenie skopiowane do schowka.": "",
        "Polecenie testowe": "",
        "Polityka prywatności": "",
        "Polski": "",
        "Pomiń": "",
        "Pominięto": "",
        "Pominięty poziom nagłówka": "",
        "Pomniejsz": "",
        "Pomoc": "",
        "Pomóż mi przesłać zdjęcie i dodać je do przygotowywanej aktualności.": "",
        "Pomóż mi przygotować nową aktualność, ale jeszcze jej nie publikuj.": "",
        "Pon-pt": "",
        "Ponów": "",
        "Ponów wyszukiwanie": "",
        "Popraw błędy formularza przed zapisaniem.": "",
        "Popraw hierarchię nagłówków bez przeskakiwania poziomów.": "",
        "Poprzedni miesiąc": "",
        "Poprzedni okres": "",
        "Poprzedni plik": "",
        "Poprzedni rok": "",
        "Poprzednia strona": "",
        "Poprzednie trafienie": "",
        "Porównaj": "",
        "Porównaj z aktualną wersją": "",
        "Porównaj: poprzedni okres": "",
        "Porównanie wersji": "",
        "Port": "",
        "Postęp całkowity": "",
        "Postęp workflow": "",
        "Postęp wysyłania": "",
        "Postęp wysyłania plików": "",
        "Potwierdź": "",
        "Potwierdź i zatwierdź plan": "",
        "Potwierdź usunięcie": "",
        "Potwierdź usunięcie filtra": "",
        "Potwierdź zmiany destrukcyjne": "",
        "Potwierdzasz tylko usuwanie danych": "",
        "Potwierdzasz usuwanie i wszystkie większe zmiany": "",
        "Potwierdzenia": "",
        "Potwierdzenie": "",
        "Potwierdzenie kopiowania": "",
        "Potwierdzenie usunięcia": "",
        "Potwierdzenie zmiany statusu": "",
        "powiadomienia": "",
        "Powiadomienia": "",
        "Powiadomienie": "",
        "Powiększ": "",
        "Powiększenie obrazu": "",
        "Powrót": "",
        "Powrót do harmonogramu zadań": "",
        "Powtórz hasło": "",
        "Powtórzone": "",
        "Poziom dostępu": "",
        "Pozostałe": "",
        "Pozostało %0 znaków.": "",
        "Pozwala przekazać własne nagłówki autoryzacyjne eksportera.": "",
        "Pozycja stopu %0": "",
        "Pozycja X znaku wodnego": "",
        "Pozycja Y znaku wodnego": "",
        "Pozycja znaku wodnego": "",
        "pozycji": "",
        "pracuje…": "",
        "Prawo": "",
        "Prawy dolny": "",
        "Prawy górny": "",
        "Prawy panel": "",
        "Preset": "",
        "Próbkowanie": "",
        "Profil": "",
        "Profil użytkownika": "",
        "Profil został zaktualizowany.": "",
        "Proporcja": "",
        "Proporcje": "",
        "Proporcje kadru": "",
        "Proszę zapisać postęp pracy i kliknąć przycisk „Aktualizuj”. Możesz również zaakceptować aktualizację poprzez odświeżenie okna przeglądarki. Brak aktualizacji może spowodować błędy.": "",
        "Prywatny": "",
        "Prywatny klucz służący do weryfikacji odpowiedzi po stronie serwera.": "",
        "Przechowywany zaszyfrowany, widoczny tylko przy edycji.": "",
        "Przeciągnij pliki albo kliknij, aby wybrać": "",
        "Przeciągnij pliki, nie foldery.": "",
        "Przeciągnij tutaj pliki lub wybierz je z dysku": "",
        "Przeciągnij, aby zmienić kolejność": "",
        "Przeczytane": "",
        "Przed": "",
        "przed chwilą": "",
        "Przed zapisem asystent powinien przedstawić plan i poprosić o zatwierdzenie konkretnej zmiany. Przeczytaj plan przed wyrażeniem zgody.": "",
        "Przeglądarka nie udostępniła obrazu ze schowka.": "",
        "Przeglądarka z której korzystasz nie wspiera powiadomień PUSH": "",
        "Przejdź do konfiguracji, aby włączyć narzędzia": "",
        "Przejdź do pliku": "",
        "Przejrzyj zmiany przed zatwierdzeniem i upewnij się, że usuwane elementy są właściwe.": "",
        "Przekreślenie": "",
        "przekroczony dozwolony rozmiar pliku (%0 MB)": "",
        "Przenieś": "",
        "Przenieś {name}": "",
        "Przenieś element": "",
        "Przenieś element %0": "",
        "Przenieś plik {name}": "",
        "Przenieś plik %0": "",
        "Przenieś rozpakowany folder w prywatne miejsce, np. Dokumenty/Edito AI. Nie zmieniaj plików wewnątrz - zawierają gotową konfigurację, instrukcje dla asystenta i token dostępu.": "",
        "Przenieś sekcję niżej": "",
        "Przenieś sekcję wyżej": "",
        "Przenieś widget %0": "",
        "Przenieś wiersz": "",
        "Przenieś wybrane elementy": "",
        "Przeniesienie": "",
        "przeniesione": "",
        "Przeniesione": "",
        "Przeniesiono widget %0 do kolumny %1, wiersza %2.": "",
        "przeniesiony do kosza": "",
        "przeniósł do kosza": "",
        "Przepisz kod wygenerowany przez aplikację, aby potwierdzić konfigurację.": "",
        "Przeskok poziomu nagłówka psuje hierarchię dokumentu. Czytniki ekranu używają tej struktury do szybkiej nawigacji po treści.": "",
        "Prześlij": "",
        "Przestawiaj widżety i dostosowuj ich ustawienia, aby uporządkować dashboard. Przycisk „Zapisz aranżację” zapisuje wyłącznie układ i ustawienia widżetów - filtry oraz pozostałe akcje są wyłączone w podglądzie.": "",
        "Przestrzeń nazw": "",
        "Przesunięcie kadru": "",
        "Przesuwa całą tabelę jako blok bez zmiany wyrównania tekstu w komórkach.": "",
        "Przesuwanie widoku": "",
        "Przesyłanie plików": "",
        "Przetestuj poprawność zapisanych kluczy": "",
        "Przetestuj ustawienia poczty": "",
        "Przetwarzane": "",
        "Przetwarzanie…": "",
        "Przezroczystość": "",
        "Przezroczystość znaku wodnego": "",
        "Przy niskim ruchu to normalne — sprawdź, czy rejestracja jest włączona na witrynie i czy wybrany okres ma sens.": "",
        "Przydatna": "",
        "Przydatna odpowiedź": "",
        "przydatne": "",
        "Przygotowanie obrazów": "",
        "Przygotowanie wysłanych plików do wyboru…": "",
        "Przygotuj dostęp do właściwego panelu Edito oraz jeden wybrany program: Codex lub aplikację Claude z kartą Code. Zainstaluj program i zaloguj się na konto z dostępem do wybranego asystenta.": "",
        "Przygotuj panel i wybrany program.": "",
        "Przykładowe polecenia do wykorzystania w rozmowie.": "",
        "Przypisanie modeli do zadań": "",
        "Przypisanie ról": "",
        "Przywróć": "",
        "Przywróć okno lintera": "",
        "Przywróć wersję": "",
        "Przywróć zestaw": "",
        "Przywrócenie": "",
        "przywrócił z kosza": "",
        "przywrócony z kosza": "",
        "Przyznaj dostęp": "",
        "Przyznaj wszystkie uprawnienia w grupie": "",
        "Publiczna nazwa lub tytuł materiału.": "",
        "Publiczny": "",
        "Publiczny klucz witryny otrzymany w konsoli Google ReCaptcha.": "",
        "Publikacja": "",
        "Pusta lista wyłącza monitoring żądań HTTP.": "",
        "Puste akapity często powstają po przypadkowym Enterze albo wklejeniu treści. Mogą robić nierówne odstępy na stronie.": "",
        "Pusty akapit": "",
        "Raportowanie błędów aplikacji i opcjonalnych danych wydajnościowych.": "",
        "ReCaptcha": "",
        "Regeneruj odpowiedź": "",
        "Rejestr zmian": "",
        "Rejestruje operacje bazodanowe jako dane telemetryczne.": "",
        "Render 3D": "",
        "Repozytorium plików": "",
        "Reset": "",
        "Reset edytora": "",
        "Reset filtrów": "",
        "Resetuj filtr": "",
        "Resetuj urządzenia 2FA": "",
        "Resetuj widok": "",
        "Roczny": "",
        "rok": "",
        "Rok": "",
        "Rola": "",
        "Rola aktywna": "",
        "Rola domyślna": "",
        "Rola jest domyślnie zaznaczona podczas dodawania nowego użytkownika.": "",
        "Rola została dodana.": "",
        "Rola została usunięta.": "",
        "Rola została zaktualizowana.": "",
        "Rola: …": "",
        "Rola: %0": "",
        "Role i uprawnienia": "",
        "Role użytkownika": "",
        "Role zostały przypisane": "",
        "Rosnąco": "",
        "Rotacja unieważnia poprzedni token. Stara paczka przestanie działać - zastąp ją nowo pobraną.": "",
        "Rozdziel komórkę": "",
        "Rozmiar": "",
        "Rozmiar czcionki": "",
        "Rozmiar logo": "",
        "rozmiar nieznany": "",
        "Rozmiar pliku": "",
        "Rozmiar tekstu": "",
        "Rozmiar zdjęcia został zmieniony.": "",
        "Rozmiar znaku wodnego": "",
        "Rozmowa": "",
        "Rozmowa została usunięta.": "",
        "Rozmowy": "",
        "Różowy": "",
        "Rozpakowany folder jest otwarty jako projekt, a zaufanie do projektu i serwera „edito” zostało zatwierdzone.": "",
        "Rozpakuj nową paczkę, otwórz jej folder jako projekt i ponów test z kroku 6.": "",
        "Rozpakuj paczkę": "",
        "Rozpoczęto przenoszenie widgetu %0.": "",
        "Rozpoznawanie treści i wzorów wizualnych.": "",
        "Rozwiń": "",
        "Rozwiń {name}": "",
        "Rozwiń menu": "",
        "Rozwiń sekcję": "",
        "Rysunek tuszem": "",
        "Scal komórki": "",
        "Schowek nie zawiera pliku do wklejenia.": "",
        "Ścieżka folderu": "",
        "Ścieżka zapisu została zmieniona.": "",
        "Ścieżka:": "",
        "sek.": "",
        "Sekcja": "",
        "Sekcje użytkownika": "",
        "Sekret aplikacji Microsoft Entra.": "",
        "Sentry": "",
        "Separatory": "",
        "Serwer SMTP": "",
        "Sesja": "",
        "Sesja nr %0": "",
        "Sesja użytkownika": "",
        "Sesja wygasła": "",
        "Sesja wygasła — zaloguj się ponownie.": "",
        "sesji": "",
        "sierpień": "",
        "Skala": "",
        "Skala obrazu": "",
        "Skala szarości": "",
        "Skonfigurowane": "",
        "Skonfiguruj aplikację uwierzytelniającą, aby kontynuować.": "",
        "Skonfiguruj dostawcę": "",
        "Skonfiguruj MCP": "",
        "Skonfiguruj model": "",
        "Skopiowano": "",
        "Skopiowano identyfikator rozmowy.": "",
        "Skopiuj polecenie": "",
        "Skrypt SQL": "",
        "Słabe": "",
        "słów": "",
        "Słowa": "",
        "Słowa kluczowe związane z treścią pliku.": "",
        "Sortowanie": "",
        "Sortowanie plików": "",
        "Sortuj według": "",
        "Sposób wyboru wartości": "",
        "Sprawdź adres panelu, aby upewnić się, że konfigurujesz właściwą instancję Edito. Następnie kliknij „Otwórz tokeny dostępu” u góry tej strony. Przejdziesz do listy swoich tokenów.": "",
        "Sprawdź dostęp użytkownika do poszczególnych funkcji. Widok uwzględnia zapisane uprawnienia i przypisane role.": "",
        "Sprawdź konfigurację przed rozpoczęciem pracy.": "",
        "Sprawdź konfigurację przed zapisaniem zmian.": "",
        "Sprawdź moduł, sekcję i filtry w ustawieniach widgetu. Upewnij się, że w module są opublikowane dokumenty.": "",
        "Sprawdź moduł, sekcję, filtry oraz uprawnienia w ustawieniach widgetu.": "",
        "Sprawdź pisownię lub wpisz krótszą frazę.": "",
        "Sprawdź pliki": "",
        "Sprawdź połączenie": "",
        "Sprawdź połączenie z Google Analytics w ustawieniach witryny (CMS → Witryny → integracja GA) oraz czy na stronie działa kod śledzenia. Możesz też wybrać dłuższy okres.": "",
        "Sprawdź SEO wskazanej strony i zaproponuj poprawki. Na razie niczego nie zapisuj.": "",
        "Sprawdź uprawnienia do modułu użytkowników i spróbuj ponownie.": "",
        "Sprawdź uprawnienia do modułu zastępstw i spróbuj ponownie.": "",
        "Sprawdź ustawienia sklepu w widgetcie i spróbuj ponownie.": "",
        "Sprawdź ustawienia sklepu w widgetcie, wybrany okres oraz czy katalog zawiera dane (sprzedaż, stany magazynowe, oceny).": "",
        "Sprawdź ustawienia widgetu i dostęp do modułu ankiet.": "",
        "Sprawdź ustawienia witryny w widgetcie i uprawnienia do modułu treści.": "",
        "Sprawdź wersję aplikacji Claude i dostęp konta do Claude Code. W razie potrzeby skontaktuj się z administratorem firmowego konta lub helpdeskiem.": "",
        "Sprawdź wybrany folder. Otwórz wyłącznie edito-codex-project albo edito-claude-code-project, zależnie od programu.": "",
        "Sprawdź, czy widget ma ustawiony sklep w ustawieniach i czy masz dostęp do modułu zamówień.": "",
        "Sprawdzamy gotowość panelu…": "",
        "Sprawdzanie poprawności kluczy": "",
        "Spróbuj ponownie": "",
        "Spróbuj ponownie. Jeśli problem się powtarza, sprawdź połączenie z siecią lub spróbuj później.": "",
        "Średnia": "",
        "Średnica kadru": "",
        "Średnie": "",
        "Środek": "",
        "Stały rozmiar kadru": "",
        "Stan konta": "",
        "Stan uprawnienia": "",
        "Standard": "",
        "Starsze": "",
        "Start": "",
        "Status": "",
        "Status dokumentu": "",
        "Steampunk": "",
        "String": "",
        "Strona": "",
        "Strona główna": "",
        "Strony": "",
        "Studio Ghibli": "",
        "styczeń": "",
        "Styl": "",
        "Styl listy numerowanej": "",
        "Styl listy punktowanej": "",
        "Styl ramki": "",
        "Styl tekstu": "",
        "Styl z Worda": "",
        "Style z Worda przenoszą ukryte klasy i właściwości, które mogą nadpisać wygląd strony poza edytorem.": "",
        "Symbole": "",
        "Synthwave": "",
        "System": "",
        "Szablon CMS": "",
        "Szablony": "",
        "Szacowany czas:": "",
        "Szczegóły": "",
        "Szczegóły folderu": "",
        "Szczegóły komunikatu": "",
        "Szczegóły kroków": "",
        "Szczegóły pliku": "",
        "Szczegóły techniczne": "",
        "Szczegóły zadania": "",
        "Szczegóły zasobu": "",
        "Szczegóły zdarzenia": "",
        "Szerokość": "",
        "Szerokość kadru": "",
        "Szerokość proporcji": "",
        "Szerokość wynikowa": "",
        "Sześć kroków do pierwszego połączenia.": "",
        "Szkic": "",
        "Szkic węglem": "",
        "Sztuczna inteligencja": "",
        "Szukaj": "",
        "Szukaj dashboardu": "",
        "Szukaj filtra…": "",
        "Szukaj języka…": "",
        "Szukaj kolumn": "",
        "Szukaj kolumn…": "",
        "Szukaj lub wpisz polecenie": "",
        "Szukaj po emoji, nazwie lub aliasie...": "",
        "Szukaj po znaku, nazwie lub aliasie...": "",
        "Szukaj roli": "",
        "Szukaj roli…": "",
        "Szukaj rozmowy": "",
        "Szukaj rozmowy…": "",
        "Szukaj uprawnienia lub modułu": "",
        "Szukaj uprawnienia lub modułu…": "",
        "Szukaj w opcjach": "",
        "Szukaj we wszystkich wersjach": "",
        "Szukaj widoku lub dokumentu…": "",
        "Szukaj witryny": "",
        "Szukaj witryny…": "",
        "Szukaj zestawu": "",
        "Szukaj…": "",
        "Szukam…": "",
        "Szybkie": "",
        "Szybkie style tabeli": "",
        "Szyfruje połączenie z serwerem poczty.": "",
        "Ta opcja służy do włączenia lub wyłączenia dziedziczenia w danym polu": "",
        "Ta operacja jest nieodwracalna.": "",
        "Ta operacja jest nieodwracalna. Wszystkie elementy w tym widoku zostaną trwale usunięte i nie będzie można ich przywrócić.": "",
        "Ta rozmowa została usunięta.": "",
        "Ta strona jest chroniona przez reCAPTCHA i Google.": "",
        "Tabela": "",
        "Tabela bez nagłówków": "",
        "Tabela bez nagłówków jest trudniejsza do zrozumienia dla czytników ekranu i gorzej opisuje relację między kolumnami a danymi.": "",
        "Tagi": "",
        "Tak": "",
        "Tarcza zegara": "",
        "Tekst": "",
        "Tekst alternatywny": "",
        "Tekst znaku wodnego": "",
        "Ten dashboard nie zawiera żadnych widgetów": "",
        "Ten element nie zawiera menu kontekstowego.": "",
        "Ten katalog jest pusty": "",
        "Ten plan usunie {count} elementów. Tej operacji nie można łatwo cofnąć.": "",
        "Ten typ widgetu nie jest dostępny w tej wersji panelu lub został usunięty.": "",
        "Tenant ID": "",
        "Teraz": "",
        "Test odczytu zakończył się poprawnie.": "",
        "Test poczty": "",
        "Testowy adres email": "",
        "Tło komórki": "",
        "Tło zostało usunięte i zapisane jako nowy plik": "",
        "To pole jest wymagane": "",
        "To uprawnienie zostało jawnie przyznane.": "",
        "To uprawnienie zostało jawnie zabronione.": "",
        "To urządzenie": "",
        "To urządzenie zostanie natychmiast wylogowane.": "",
        "Token i paczka nie zostały udostępnione innym osobom.": "",
        "Token i paczka są Twoimi prywatnymi danymi.": "",
        "Token mógł wygasnąć, zostać usunięty albo zrotowany. Utwórz lub zrotuj token w panelu, pobierz nową paczkę i otwórz jej folder jako projekt.": "",
        "Tokeny dostępu": "",
        "Traktuj paczkę i rozpakowany folder jak hasło - zawierają prywatny token, który działa w zakresie uprawnień Twojego konta Edito.": "",
        "Transformacje": "",
        "Treść": "",
        "Treść publiczna nie powinna prowadzić do panelu administracyjnego ani endpointów admina. Dla użytkownika taki link najczęściej kończy się błędem lub ekranem logowania.": "",
        "True": "",
        "Trwa bezpieczne logowanie przez Azure AD…": "",
        "Trwa generowanie obrazów": "",
        "Trwa generowanie opisu dla wybranego obrazu": "",
        "Trwa konserwacja": "",
        "Tryb akordeonu": "",
        "Tryb ciemny": "",
        "Tryb działania": "",
        "Tryb jasny": "",
        "Tryb kadrowania": "",
        "Turkusowy": "",
        "Tutaj ustawiasz opis obrazka. Opcje techniczne są w zakładce Zaawansowane.": "",
        "Twarda spacja": "",
        "Twój asystent, połączony z Edito": "",
        "Twój wybór": "",
        "Twoje generowania pojawią się tutaj.": "",
        "Twoje hasło wygasło. Zmień je na nowe.": "",
        "Twoje konto nie ma dostępu do tego zasobu.\nPoproś administratora o nadanie uprawnienia.": "",
        "Tworzenie i edycja wpisów": "",
        "Tworzenie obrazów…": "",
        "Tworzenie, edycja i modyfikacja grafik.": "",
        "Tydzień": "",
        "Tylko aktywna rola wpływa na uprawnienia przypisanych użytkowników.": "",
        "Tylko moje": "",
        "Typ": "",
        "Typ breakpointu": "",
        "Typ integracji określa sposób uwierzytelniania.": "",
        "Typ konta": "",
        "Typ obiektu": "",
        "Typ pliku": "",
        "Typ właściwy": "",
        "Typ znaku wodnego": "",
        "typu \"%0\" o ID \"%1\"": "",
        "Typy elementów w koszu": "",
        "Tytuł sekcji": "",
        "Udział dozwolonych uprawnień": "",
        "Układ": "",
        "Układ kolumn": "",
        "Układ listy": "",
        "Układ nie został otwarty, dlatego dodawanie widgetów i zapis są zablokowane. Spróbuj pobrać dane ponownie.": "",
        "Układ widgetów dashboardu": "",
        "Układy kolumn": "",
        "Ukryj hasło": "",
        "Ukryj klucz prywatny": "",
        "Ukryj postęp wysyłania": "",
        "Ukryj rozmowy": "",
        "Ukryj szczegóły": "",
        "Ukryj wszystkie": "",
        "Ulubione": "",
        "Upewnij się, że widget ma ustawiony właściwy sklep (menu widgetu → Ustawienia) i sprawdź, czy w tym okresie pojawiły się zamówienia. Zmiana okresu w nagłówku może pomóc.": "",
        "Uprawnienia": "",
        "Uprawnienia indywidualne": "",
        "Uprawnienia ogólne": "",
        "Uprawnienia roli": "",
        "Uprawnienia z ról łączą się z indywidualnymi.": "",
        "Upuść pliki, aby dodać je do kolejki": "",
        "Upuść pliki, żeby je dołączyć": "",
        "Upuść tutaj": "",
        "Upuść, aby dodać": "",
        "Uri / ConnectionString": "",
        "URL": "",
        "Uruchamiam wykonanie planu...": "",
        "Uruchom gotowy projekt bez używania terminala.": "",
        "Uruchom zadanie": "",
        "urządzeń": "",
        "Urządzenia uwierzytelniające": "",
        "Urządzenia uwierzytelniające zostały zresetowane.": "",
        "Urządzenie nie zostało znalezione.": "",
        "Urządzenie zostało usunięte.": "",
        "Usługa AI jest obecnie niedostępna. Spróbuj ponownie za chwilę.": "",
        "Usługa rozmów jest niedostępna. Pobierz rozmowy ponownie, aby sprawdzić połączenie.": "",
        "Usługa wyszukiwania nie odpowiedziała. Widoki i polecenia działają normalnie.": "",
        "Ustaw dla całej grupy": "",
        "Ustaw dziedziczenie wszystkich uprawnień w grupie": "",
        "Ustaw nazwę i opis dashboardu.": "",
        "Ustaw nowe hasło": "",
        "Ustaw poziomy logów, które będą wysyłane do poszczególnych rejestrów.": "",
        "Ustaw poziomy logów, które będą zbierane z poszczególnych przestrzeni nazw.": "",
        "Ustaw prawdziwy adres albo usuń linkowanie z tego fragmentu tekstu.": "",
        "Ustaw realny adres linku albo usuń link.": "",
        "Ustaw ścieżkę": "",
        "Ustaw własne wymiary": "",
        "Ustaw wyjątki względem dostępu wynikającego z ról. Zmiany zatwierdzisz przyciskiem zapisu użytkownika.": "",
        "Ustawienia": "",
        "Ustawienia kolumn": "",
        "Ustawienia roli": "",
        "Ustawienia weryfikacji dwuetapowej zostały zapisane.": "",
        "Ustawienia widgetów zostały zapisane": "",
        "Ustawienia widgetu": "",
        "Ustawienia wspólne": "",
        "Ustawienia zostały zapisane.": "",
        "Ustawienie logo witryny jako znaku wodnego": "",
        "Ustawienie obowiązuje tylko w tej rozmowie. Nowe rozmowy startują w trybie z potwierdzaniem operacji.": "",
        "Usuń": "",
        "USUŃ": "",
        "Usuń akapit. Jeśli odstęp jest celowy, użyj elementu layoutu albo stylu przewidzianego dla tej treści.": "",
        "Usuń bieżącą kolumnę": "",
        "Usuń blok kodu": "",
        "Usuń filtr": "",
        "Usuń formatowanie": "",
        "Usuń kolumnę": "",
        "Usuń kontekst strony": "",
        "Usuń link": "",
        "Usuń napisy": "",
        "Usuń obraz": "",
        "Usuń obraz startowy": "",
        "Usuń plik": "",
        "Usuń plik z listy": "",
        "Usuń pusty akapit, jeśli nie jest potrzebny jako świadomy odstęp.": "",
        "Usuń rozmowę": "",
        "Usuń sekcję": "",
        "Usuń tabelę": "",
        "Usuń tło": "",
        "Usuń trwale": "",
        "Usuń układ kolumn": "",
        "Usuń urządzenie": "",
        "Usuń urządzenie, aby odwołać zapamiętane automatyczne logowanie.": "",
        "Usuń wariant breakpointu": "",
        "Usuń widget z dashboardu (menu ⋮ → Usuń) albo skontaktuj się z administratorem systemu.": "",
        "Usuń wiersz": "",
        "Usuń wklejone style Worda i zostaw formatowanie z edytora.": "",
        "Usuń wszystkie": "",
        "Usuń wybrane elementy": "",
        "Usuń załącznik": "",
        "Usuń zasób": "",
        "Usunąć całą historię rozmów? Tej operacji nie można cofnąć.": "",
        "Usunąć tę rozmowę?": "",
        "usunął": "",
        "Usunął": "",
        "Usunięcie": "",
        "usunięte": "",
        "Usunięte": "",
        "usunięto": "",
        "usunięty": "",
        "Usuwanie tła...": "",
        "Utwórz katalog": "",
        "Utwórz osobisty token, pobierz gotowy projekt i otwórz go w Codexie lub Claude Code. Poniżej znajdziesz dokładną kolejność działań oraz polecenie sprawdzające połączenie.": "",
        "Utwórz token": "",
        "Utworzone zasoby": "",
        "Utworzył": "",
        "Uwierzytelnianie tokenem Microsoft 365.": "",
        "Uzupełnij wymagane pola przed testem.": "",
        "Uzupełnij wymagane ustawienia źródła danych tego widgetu.": "",
        "Użycia": "",
        "Użyte narzędzia": "",
        "Użytkownicy": "",
        "Użytkownicy w tej roli": "",
        "Użytkownik": "",
        "Użytkownik \"%0\" %1 obiekt %2": "",
        "Użytkownik ma pełny dostęp niezależnie od indywidualnych przypisań. Lista obejmuje tylko zapisane wpisy.": "",
        "Użytkownik nie będzie otrzymywał żadnych powiadomień.": "",
        "Użytkownik nie może się zalogować, dopóki konto nie jest aktywne.": "",
        "Użytkownik usunięty": "",
        "Użytkownik zablokowany": "",
        "Użytkownik zatwierdzony": "",
        "Użytkownik został dodany.": "",
        "Użytkownik został usunięty.": "",
        "Użytkownik został utworzony. Możesz zalogować się na swoje konto.": "",
        "Użytkownik został wylogowany.": "",
        "Użytkownik został zaktualizowany.": "",
        "Użytkownik został zanonimizowany.": "",
        "Używany do budowy linków w treści wiadomości.": "",
        "W czym mogę pomóc?": "",
        "W dniach miesiąca": "",
        "W dniach tygodnia": "",
        "W lewo": "",
        "W menu z trzema kropkami wybierz „Rotuj”. Przeczytaj komunikat i potwierdź, jeśli chcesz zastąpić dotychczasowy token.": "",
        "W miesiącach": "",
        "W minutach": "",
        "W nowej rozmowie wyślij poniższe polecenie:": "",
        "W polu „Data wygaśnięcia” wybierz uzgodniony termin ważności.": "",
        "W polu „Nazwa” wpisz nazwę programu i swoje imię, np. „Codex - Anna Kowalska”. Dzięki temu rozpoznasz token na liście.": "",
        "W prawo": "",
        "W recenzji": "",
        "W toku": "",
        "W tym miejscu można wybrać tylko jeden plik.": "",
        "W widoku nowego tokenu pobierz paczkę dla swojego programu, zanim zamkniesz okno.": "",
        "W wybranym okresie nie ma zamówień spełniających kryteria tego widgetu.": "",
        "W wybranym okresie nie odnotowano ruchu w Google Analytics dla tej witryny.": "",
        "w zakresie": "",
        "Walidacja certyfikatu SSL": "",
        "Walidacja treści": "",
        "Wariant dla": "",
        "Wariant mobilny dodawaj tylko wtedy, gdy na telefonie ma się wyświetlić inna grafika.": "",
        "Warianty responsywne": "",
        "Wartość domyślna": "",
        "Wartość musi być liczbą całkowitą": "",
        "Wartość musi być liczbą dodatnią": "",
        "Wartość musi być liczbą ujemną": "",
        "Wartości od 0 do 1. 0 oznacza 0%, a 1 oznacza 100%.": "",
        "Warunki korzystania z usług Google": "",
        "Wbudowane": "",
        "Wczoraj": "",
        "Wczytaj więcej": "",
        "Wczytanie obrazu": "",
        "wczytuje rozmowę…": "",
        "Wczytuję rozmowę...": "",
        "Wczytywanie": "",
        "Wczytywanie aktywnych sesji": "",
        "Wczytywanie dziennika…": "",
        "Wczytywanie emoji...": "",
        "Wczytywanie folderów": "",
        "Wczytywanie historii wersji…": "",
        "Wczytywanie konfiguracji AI…": "",
        "Wczytywanie miejsc użycia": "",
        "Wczytywanie plików": "",
        "Wczytywanie powiadomień": "",
        "Wczytywanie ról": "",
        "Wczytywanie rozmów…": "",
        "Wczytywanie układu dashboardu": "",
        "Wczytywanie uprawnień": "",
        "Wczytywanie ustawień zabezpieczeń…": "",
        "Wczytywanie zapamiętanych urządzeń": "",
        "Wczytywanie zdarzenia…": "",
        "Wczytywanie…": "",
        "Wdrożenie": "",
        "We wszystkich folderach": "",
        "Weekend": "",
        "wejść": "",
        "wejścia": "",
        "wejście": "",
        "Wektoryzacja tekstu": "",
        "Wektoryzacja tekstu, analiza semantyczna": "",
        "Wersja": "",
        "Wersja API": "",
        "Wersja backendu: %0": "",
        "Wersja compact": "",
        "Wersja językowa": "",
        "Weryfikacja dwuetapowa": "",
        "Weryfikacja dwuetapowa (2FA)": "",
        "Weryfikacja dwuetapowa jest dostępna wyłącznie dla kont lokalnych.": "",
        "Weryfikacja dwuetapowa jest wymagana przez system.": "",
        "Weryfikacja dwuetapowa została wyłączona.": "",
        "Wiadomość": "",
        "Wiadomość do asystenta": "",
        "Wiadomość testowa została wysłana.": "",
        "Widget": "",
        "Widget nie ma danych do wyświetlenia przy obecnych ustawieniach.": "",
        "Widget w trakcie przygotowywania": "",
        "Widget wymaga konfiguracji": "",
        "Widoczna na liście dostawców i w wyborze modeli.": "",
        "Widoczne": "",
        "Widoczność": "",
        "Widoczność filtra": "",
        "Widok": "",
        "Widok plików": "",
        "Więcej": "",
        "Więcej akcji": "",
        "Więcej akcji widgetu %0": "",
        "Więcej informacji": "",
        "Wiele rozwinięć": "",
        "Wiersz nagłówkowy": "",
        "Wiersze": "",
        "Wiersze naprzemienne": "",
        "Windows: w folderze „Pobrane” kliknij ZIP prawym przyciskiem i wybierz „Wyodrębnij wszystkie”.": "",
        "Wizja": "",
        "Wklej": "",
        "Wklej adres strony dokumentu Studio albo wpisz moduł/sekcja/id.": "",
        "Wklej adres URL…": "",
        "Wklej bez formatowania": "",
        "Wklej link do dokumentu Studio w formacie /modules/moduł/sekcja/id.": "",
        "Wklej treść jako czysty tekst albo usuń formatowanie i ustaw je ponownie narzędziami edytora.": "",
        "Włącz": "",
        "Włącz pełną autonomię": "",
        "Włącza śledzenie transakcji i pomiar wydajności.": "",
        "Włączona": "",
        "Włączone": "",
        "Włączyć pełną autonomię?": "",
        "Właściwości komórki": "",
        "Właściwości tabeli": "",
        "Własne klasy zależą od stylów projektu i nie są odwzorowane w podglądzie.": "",
        "Własny": "",
        "Własny breakpoint": "",
        "Własny przedział": "",
        "Własny rozmiar (np. 13px)": "",
        "Wpisz 6-cyfrowy kod": "",
        "Wpisz adresy po przecinku.": "",
        "Wpisz co najmniej %0 znaki, aby przeszukać strony i dokumenty.": "",
        "Wpisz czytelny tekst linku, dodaj obraz z altem albo usuń pusty link.": "",
        "Wpisz USUŃ, aby odblokować wykonanie:": "",
        "Wpisz, aby wyszukać…": "",
        "Wprowadzona wartość jest nieprawidłowa": "",
        "Wprowadzona wartość jest za długa": "",
        "Wprowadzona wartość jest za krótka": "",
        "Wprowadzona wartość jest za niska": "",
        "Wprowadzona wartość jest za wysoka": "",
        "Wprowadzona wartość nie jest poprawna": "",
        "Wróć do logowania": "",
        "Wróć do pulpitu": "",
        "Wróć do rozmowy": "",
        "Wróć do widoku nowego lub zrotowanego tokenu i pobierz właściwy wariant: edito-codex-project.zip dla Codexa albo edito-claude-code-project.zip dla Claude Code.": "",
        "Wróć do zmian": "",
        "wrzesień": "",
        "Wskaż rozpakowany folder:": "",
        "Wspólne": "",
        "Wstaw": "",
        "Wstaw / edytuj multimedia": "",
        "Wstaw akordeon": "",
        "Wstaw blok kodu": "",
        "Wstaw cytat": "",
        "Wstaw cztery kolumny 1/4": "",
        "Wstaw dwie kolumny 1/3 oraz 2/3": "",
        "Wstaw dwie kolumny 2/3 oraz 1/3": "",
        "Wstaw dwie równe kolumny": "",
        "Wstaw kolumnę z lewej": "",
        "Wstaw kolumnę z prawej": "",
        "Wstaw kotwicę": "",
        "Wstaw linię poziomą": "",
        "Wstaw link": "",
        "Wstaw multimedia": "",
        "Wstaw obraz": "",
        "Wstaw plik": "",
        "Wstaw tabelę": "",
        "Wstaw trzy kolumny 1/2, 1/4 oraz 1/4": "",
        "Wstaw trzy kolumny 1/3": "",
        "Wstaw trzy kolumny 1/4, 1/2 oraz 1/4": "",
        "Wstaw trzy kolumny 1/4, 1/4 oraz 1/2": "",
        "Wstaw układ": "",
        "Wstaw wiersz poniżej": "",
        "Wstaw wiersz powyżej": "",
        "Wstaw/edytuj obraz": "",
        "Wstawianie": "",
        "Wstawki": "",
        "Wszyscy użytkownicy": "",
        "Wszystkie": "",
        "Wszystkie dane osobowe użytkownika znajdujące się w systemie zostaną usunięte!\n\nCzy na pewno chcesz wykonać akcję?": "",
        "Wszystkie elementy": "",
        "Wszystkie filtry są już dodane.": "",
        "Wszystkie kroki zostały wykonane.": "",
        "Wszystkie urządzenia uwierzytelniające tego użytkownika zostaną usunięte.\n\nCzy na pewno chcesz wykonać akcję?": "",
        "Wszystkie wiersze": "",
        "Wszystko zaznaczone": "",
        "Wybierz": "",
        "Wybierz „Pobierz projekt dla Claude Code”.": "",
        "Wybierz „Pobierz projekt dla Codexa”.": "",
        "Wybierz docelową ścieżkę zapisu.": "",
        "Wybierz dokument z listy.": "",
        "Wybierz dostawcę": "",
        "Wybierz emoji": "",
        "Wybierz godzinę": "",
        "Wybierz ikonę": "",
        "Wybierz ikonę filtra": "",
        "Wybierz ikonę...": "",
        "Wybierz inny rodzaj operacji albo inną grupę.": "",
        "Wybierz jeden lub kilka stylów. Podgląd aktualizuje się przed zapisaniem zmian.": "",
        "Wybierz katalog docelowy dla zaznaczonych plików i katalogów.": "",
        "Wybierz kolor": "",
        "Wybierz kolor tekstu": "",
        "Wybierz kolor tła": "",
        "Wybierz logo": "",
        "Wybierz minutę": "",
        "Wybierz model": "",
        "Wybierz napisy ze storage": "",
        "Wybierz obraz ze storage": "",
        "Wybierz odbiorcę danych telemetrycznych.": "",
        "Wybierz paczkę zgodną ze swoim asystentem.": "",
        "Wybierz plik": "",
        "Wybierz plik .vtt ze storage": "",
        "Wybierz plik napisów w formacie WebVTT (.vtt).": "",
        "Wybierz pliki": "",
        "Wybierz pliki (do {0})": "",
        "Wybierz rolę lub osobę": "",
        "Wybierz rozpakowany folder projektu, a nie ZIP ani cały folder „Pobrane”. Nie trzeba kopiować konfiguracji do ustawień aplikacji, instalować Claude Code CLI ani wpisywać komend w terminalu.": "",
        "Wybierz ścieżkę zapisu": "",
        "Wybierz sposób potwierdzania logowania do swojego konta.": "",
        "Wybierz środowisko „Local”, kliknij „Select folder” i wskaż folder:": "",
        "Wybierz układ kolumn": "",
        "Wybierz użytkowników dla których chcesz wykonać akcje": "",
        "Wybierz wersję %0": "",
        "Wybierz witrynę w ustawieniach tego widgetu.": "",
        "Wybierz z dysku": "",
        "Wybierz zdjęcie użytkownika": "",
        "Wybierz ze storage": "",
        "Wybierz znak specjalny": "",
        "Wybierz, kto ma dostęp do dashboardu.": "",
        "Wybierz...": "",
        "Wybierz…": "",
        "Wybór języka": "",
        "Wybrana data jest poza dozwolonym zakresem.": "",
        "Wybrane": "",
        "Wybrane elementy zostały przeniesione.": "",
        "Wybrane elementy zostały przywrócone.": "",
        "Wybrane elementy zostały trwale usunięte.": "",
        "Wybrane elementy zostały usunięte.": "",
        "Wybrane pliki": "",
        "Wybrane: %0": "",
        "Wybranie dostawcy jest wymagane.": "",
        "Wybrano %0 użytkowników.": "",
        "Wybrano jednego użytkownika.": "",
        "Wybrano:": "",
        "Wybrany element został usunięty.": "",
        "Wyczyść": "",
        "Wyczyść filtry": "",
        "Wyczyść historię": "",
        "Wyczyść kolejkę": "",
        "Wyczyść styl": "",
        "Wyczyść styl tabeli": "",
        "Wyczyść wartość": "",
        "Wyczyść wybór": "",
        "Wyczyść wyszukiwanie": "",
        "Wyczyść zaznaczenie (Esc)": "",
        "Wygasa:": "",
        "Wygenerowane obrazy": "",
        "Wygenerowany obraz": "",
        "Wyjustuj": "",
        "Wykluczenia logów konsoli": "",
        "Wykonaj": "",
        "Wykonane zmiany": "",
        "Wykonanie planu zostało anulowane.": "",
        "Wykonano": "",
        "Wykonuję operację...": "",
        "Wykonuję plan...": "",
        "Wykonywanie": "",
        "Wykres danych dashboardu": "",
        "Wyłącz 2FA": "",
        "Wyłączona": "",
        "wyłączone (użytkownik decyduje sam)": "",
        "Wyłączone wysyłanie powiadomień": "",
        "Wyloguj się": "",
        "Wyloguj zalogowanego obecnie użytkownika": "",
        "wymaga uwagi": "",
        "Wymaga zatwierdzenia powyżej.": "",
        "Wymagaj znaków specjalnych w hasłach": "",
        "Wymagana tylko dla Azure OpenAI.": "",
        "wymagane - Authenticator": "",
        "wymagane - dowolna metoda": "",
        "wymagane - Email": "",
        "Wymagane jest ustawienie minimalnej długości hasła": "",
        "Wymagania stawiane hasłom użytkowników panelu.": "",
        "Wymagany": "",
        "Wymiary": "",
        "Wymiary HTML obrazu głównego": "",
        "Wymiary HTML wariantu": "",
        "Wymiary obrazu": "",
        "Wymuś zmianę hasła": "",
        "Wynik": "",
        "Wynika z roli": "",
        "Wyniki": "",
        "Wyniki wyszukiwania": "",
        "Wypełnij miniaturę": "",
        "Wypełnij miniaturę – przytnij obraz": "",
        "Wypróbuj możliwości AI": "",
        "Wyrażenie własne": "",
        "Wyrównanie": "",
        "Wyrównanie multimediów": "",
        "Wyrównanie obrazu": "",
        "Wyrównanie pionowe": "",
        "Wyrównanie tekstu": "",
        "Wyróżnione": "",
        "Wysłane": "",
        "wysłano": "",
        "Wysłano": "",
        "Wyślij": "",
        "Wyślij kod": "",
        "Wyślij pliki": "",
        "Wyślij ponownie": "",
        "Wyślij ponownie (%0s)": "",
        "Wysoka": "",
        "Wysokość": "",
        "Wysokość kadru": "",
        "Wysokość proporcji": "",
        "Wysokość stała dla tego typu widżetu.": "",
        "Wysokość wynikowa": "",
        "Wyśrodkuj": "",
        "Wystąpił błąd podczas ładowania obrazu. Spróbuj ponownie.": "",
        "Wystąpił błąd podczas próby exportu użytkowników.": "",
        "Wystąpił błąd podczas próby importu użytkowników.": "",
        "Wystąpił błąd połączenia. Upewnij się że masz włączony internet i spróbuj ponownie.": "",
        "Wystąpił błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił nieznany błąd serwera podczas obsługiwania wybranej operacji. Spróbuj ponownie.": "",
        "Wystąpił problem podczas pobierania danych widgetu.": "",
        "Wystąpił problem podczas przetwarzania obrazu.": "",
        "Wyświetlana jako autor wiadomości.": "",
        "Wyświetlany domyślnie na wszystkich ekranach, jeśli nie dodasz osobnego wariantu mobilnego.": "",
        "wyświetleń": "",
        "Wysyłaj dane o użytkowniku": "",
        "wysyłanie niedostępne": "",
        "Wysyłanie plików": "",
        "Wysyłanie wiadomości niedostępne": "",
        "Wysyłanie…": "",
        "Wyszukaj emoji": "",
        "Wyszukaj ikonę": "",
        "Wyszukaj ikonę...": "",
        "Wyszukaj widget": "",
        "Wyszukaj widget...": "",
        "Wyszukaj znak specjalny": "",
        "Wyszukaj...": "",
        "Wyszukaj…": "",
        "Wyszukiwanie i polecenia": "",
        "Wytnij": "",
        "Wyzeruj": "",
        "Wzmacnia obrys tabeli i linie siatki, dzięki czemu układ jest bardziej wyraźny.": "",
        "X": "",
        "Y": "",
        "z": "",
        "Z komentarzem": "",
        "Z uprawnieniami": "",
        "za %0 %1": "",
        "za chwilę": "",
        "Zaakceptowany": "",
        "Zaawansowane": "",
        "Zabierz dostęp": "",
        "Zablokuj": "",
        "Zablokuj proporcje": "",
        "Zablokuj proporcje wariantu": "",
        "Zabroń - jawnie odebrane": "",
        "Zabroń wszystkich uprawnień w grupie": "",
        "Zabronione": "",
        "Zacznij nową rozmowę - pojawi się tutaj.": "",
        "Zacznij pisać, aby wyszukać użytkownika…": "",
        "Zacznij w instancji Edito, z którą chcesz pracować.": "",
        "Zadaj pytanie albo poproś o akcję - asystent korzysta z modułów CMS.": "",
        "Zadanie zostało uruchomione.": "",
        "Zadanie zostało włączone": "",
        "Zadanie zostało wyłączone": "",
        "Żądany zasób jest niedostępny albo żądanie jest nieprawidłowe.\nSprawdź adres lub wróć do panelu.": "",
        "Żadna rozmowa nie pasuje do wyszukiwania.": "",
        "Zaimportowano listę użytkowników.": "",
        "Zakolejkowane": "",
        "Zakończ": "",
        "Zakończ sesję, aby natychmiast wylogować to urządzenie.": "",
        "Zakończone": "",
        "Zakończono": "",
        "Zakończono z błędami": "",
        "Zakres": "",
        "Zakres danych": "",
        "Zakres witryny i języka": "",
        "Zalecane": "",
        "Zalogowano jako": "",
        "Zalogowany": "",
        "Zaloguj się": "",
        "Zaloguj się do właściwego panelu i pobierz nową paczkę. Nie przenoś paczek między instancjami.": "",
        "Zaloguj się na swoje konto, aby przejść do panelu.": "",
        "Zamień": "",
        "Zamień na": "",
        "Zamień na…": "",
        "Zamknij": "",
        "Zamknij asystenta": "",
        "Zamknij komunikat": "",
        "Zamknij menu": "",
        "Zamknij panel": "",
        "Zamknij pełny ekran": "",
        "Zamknij podgląd": "",
        "Zamknij projekt i otwórz ponownie folder właściwy dla wybranego programu. Jeśli pojawi się pytanie, zatwierdź zaufanie do projektu i serwera „edito”, a następnie ponów test odczytu.": "",
        "Zamknij wybór plików": "",
        "Zaokrąglenie rogów": "",
        "Zapamiętaj logowanie": "",
        "Zapamiętane automatyczne logowanie dla tego urządzenia zostanie odwołane.": "",
        "Zapamiętane urządzenia": "",
        "Zapis do:": "",
        "Zapis obejmuje filtry, sortowanie i kolumny.": "",
        "Zapisane": "",
        "Zapisane filtry": "",
        "Zapisano pozycję widgetu %0.": "",
        "Zapisywanie obrazów zakończone.": "",
        "Zapisywanie obrazów...": "",
        "Zapisywanie obrazu...": "",
        "Zapisz": "",
        "Zapisz aranżację": "",
        "Zapisz do katalogu": "",
        "Zapisz i wróć": "",
        "Zapisz i zamknij": "",
        "Zapisz jako nowe pliki": "",
        "Zapisz jako nowy": "",
        "Zapisz kolejność": "",
        "Zapisz konfigurację w prywatnym folderze.": "",
        "Zapisz nazwę": "",
        "Zapisz nowe hasło": "",
        "Zapisz ustawienia": "",
        "Zapisz użytkownika": "",
        "Zapisz widget": "",
        "Zaplanowane": "",
        "Zapytanie do modułu dynamicznego nie zwróciło żadnych rekordów.": "",
        "Zarządzaj aktywnymi sesjami i zaufanymi urządzeniami przypisanymi do Twojego konta.": "",
        "Zarządzaj aplikacjami, które generują kody logowania do konta.": "",
        "Zasady haseł": "",
        "Zastępstwo": "",
        "Zastosuj": "",
        "Zastosuj modyfikacje": "",
        "Zatrzymaj": "",
        "Zatrzymaj odpowiedź": "",
        "Zatwierdź plan": "",
        "Zaufane adresy IP": "",
        "Zawieszeni 30 dni+": "",
        "Zaznacz": "",
        "Zaznacz co najmniej jeden plik.": "",
        "Zaznacz obraz": "",
        "Zaznacz obrazy, które chcesz zapisać w katalogu.": "",
        "Zaznacz pliki w bibliotece, aby pojawiły się tutaj.": "",
        "Zaznacz wiersz": "",
        "Zaznacz wszystkie komórki": "",
        "Zaznacz wszystkie wiersze": "",
        "Zaznacz wszystko": "",
        "Zaznaczenie jest zachowane przy zmianie folderu.": "",
        "Zaznaczenie zawiera plik w formacie niedozwolonym w tym polu.": "",
        "Zaznaczone zadania będą mogły korzystać z tego modelu.": "",
        "zaznaczono %0": "",
        "Zbiera metryki środowiska uruchomieniowego .NET.": "",
        "Zbieranie i przechowywanie logów": "",
        "Zdarzenie": "",
        "Zdjęcie użytkownika": "",
        "Zeskanuj kod QR": "",
        "Zeskanuj w aplikacji": "",
        "Zespół": "",
        "Zespół w nowoczesnym biurze, naturalne światło": "",
        "Zespół: %0": "",
        "Zestaw został zaktualizowany.": "",
        "Zestaw został zapisany.": "",
        "Zewnętrzny MCP": "",
        "Zezwól - jawnie przyznane": "",
        "Zgodny z API OpenAI": "",
        "zmian w planie": "",
        "Zmiana": "",
        "Zmiana filtrów": "",
        "Zmiana hasła": "",
        "Zmiana jednego wymiaru zachowuje proporcje obrazu.": "",
        "Zmiana optymalizacji wymiarów": "",
        "Zmiana pozycji znaku wodnego": "",
        "Zmiana proporcji kadrowania": "",
        "Zmiana rozmiaru kadru": "",
        "Zmiana rozmiaru obrazu": "",
        "Zmiana skali": "",
        "Zmiana trybu kadrowania": "",
        "Zmiana ustawień może doprowadzić do utraty dostępu do panelu!\n\nCzy na pewno chcesz zapisać zmiany?": "",
        "Zmiana wymiarów obrazu": "",
        "Zmiana znaku wodnego": "",
        "Zmiany niewykonane": "",
        "Zmiany pól": "",
        "Zmiany pominięte": "",
        "Zmiany ustawień monitoringu wymagają restartu aplikacji.": "",
        "Zmiany w planie": "",
        "Zmiany zostały zapisane.": "",
        "Zmień": "",
        "Zmień filtry lub rozszerz zakres wyszukiwania.": "",
        "Zmień hasło": "",
        "Zmień hasło używane do logowania do konta.": "",
        "Zmień kolejność elementów": "",
        "Zmień kolejność wierszy": "",
        "Zmień komórki pierwszego wiersza lub kolumny na nagłówki TH.": "",
        "Zmień lub skróć wpisaną frazę.": "",
        "Zmień motyw: %0": "",
        "Zmień nazwę": "",
        "Zmień nazwę katalogu": "",
        "Zmień nazwę pliku": "",
        "Zmień nazwę rozmowy": "",
        "Zmień nazwę urządzenia": "",
        "Zmień obraz": "",
        "Zmień rozmiar": "",
        "Zmień rozmiar okna": "",
        "Zmień ścieżkę zapisu": "",
        "Zmień szerokość okna": "",
        "Zmień szukaną nazwę uprawnienia lub modułu.": "",
        "Zmień treść wiadomości...": "",
        "Zmień wysokość okna": "",
        "Zmień wyszukiwanie lub wybrany stan.": "",
        "Zmienić wspólny zestaw dla innych użytkowników?": "",
        "zmienione": "",
        "Zmienione": "",
        "Zmieniono": "",
        "Zmniejsz": "",
        "Zmniejsz duże obrazy do WWW": "",
        "Zmniejsz wcięcie": "",
        "Zmniejsza odstępy w komórkach, żeby tabela była gęstsza i zajmowała mniej miejsca.": "",
        "zmodyfikował": "",
        "Zmodyfikował": "",
        "Zmodyfikowano": "",
        "zmodyfikowany": "",
        "Zmodyfikuj obraz": "",
        "Znaczniki": "",
        "Znajdź i zamień": "",
        "Znajdź ostatnio zmienione treści i krótko je podsumuj.": "",
        "Znajdź w treści": "",
        "Znajdź w treści…": "",
        "Znak specjalny": "",
        "Znak wodny": "",
        "Znaki": "",
        "Znaki specjalne": "",
        "znaków": "",
        "Zobacz sesję użytkownika": "",
        "Zobacz szczegóły sesji użytkownika": "",
        "Zobacz szczegóły zdarzenia": "",
        "Zobacz wszystkie": "",
        "Zobacz wszystkie zmiany": "",
        "Zobacz wszystko": "",
        "Żółty": "",
        "Został przywrócony oryginalny harmonogram": "",
        "Zrestartuj aplikację": "",
        "Źródła logów": "",
        "Źródła uprawnień": "",
        "Źródło": "",
        "Źródło materiału": "",
        "Źródło wariantu": "",
        "Zweryfikuj konfigurację integracji GA dla wybranej witryny i spróbuj odświeżyć dashboard.": "",
        "Zwiększ": "",
        "Zwiększ wcięcie": "",
        "Zwiń": "",
        "Zwiń {name}": "",
        "Zwiń menu": "",
        "Zwiń sekcję": "",
        "Zwrócony": ""
    }
};
